export default {
  'header.homepage': 'الصفحة الرئيسية',
  'header.workspace': 'مساحة العمل',
  'login.title': 'AIMATEX',
  'login.welcome': 'مرحباً بك في AIMATEX',
  'login.description': 'AIMATEX منصتك للمساعد بالذكاء الاصطناعي. خدمات آمنة ومريحة. الوصول إلى جميع ملفاتك في أي وقت وأي مكان.',
  'login.email.placeholder': 'البريد الإلكتروني أو اسم المستخدم',
  'login.password.placeholder': 'كلمة المرور',
  'login.button': 'تسجيل الدخول',
  'login.loading': 'جاري تسجيل الدخول...',
  'login.divider': 'أو',
  'login.signup': 'ليس لديك حساب؟',
  'login.signup.link': 'سجل الآن',
  'login.error.default': 'فشل تسجيل الدخول، يرجى المحاولة لاحقاً',
  'login.success': 'تم تسجيل الدخول',
  'login.forgotPassword': 'نسيت كلمة المرور؟',
  'login.forgotPassword.link': 'إعادة تعيين هنا',
  'login.rememberPassword': 'تذكر كلمة المرور',
  'login.social.comingSoon': 'طريقة تسجيل الدخول هذه قيد التطوير',
  'captcha.placeholder': 'رمز التحقق',
  'captcha.refresh': 'تحديث رمز التحقق',
  'auth.modal.title': 'تسجيل الدخول مطلوب',
  'auth.modal.content': 'انتهت صلاحية جلستك أو أنك غير مسجل الدخول. يرجى تسجيل الدخول للمتابعة.',
  'auth.modal.ok': 'الذهاب لتسجيل الدخول',
  'auth.modal.cancel': 'لاحقاً',
  'signup.page.title': 'التسجيل - AIMATEX',
  'signup.title': 'AIMATEX',
  'signup.welcome': 'مرحباً بك في AIMATEX',
  'signup.description': 'أنشئ حسابك وابدأ رحلة الإبداع بالذكاء الاصطناعي',
  'signup.feature.ai': 'مدعوم بالذكاء الاصطناعي',
  'signup.feature.video': 'إنشاء الفيديو',
  'signup.feature.fast': 'إنشاء سريع',
  'signup.feature.creative': 'إبداع لا حدود له',
  'signup.username.placeholder': 'أدخل اسم المستخدم',
  'signup.email.placeholder': 'أدخل البريد الإلكتروني',
  'signup.password.placeholder': 'أدخل كلمة المرور',
  'signup.confirmPassword.placeholder': 'تأكيد كلمة المرور',
  'signup.inviteCode.placeholder': 'رمز الدعوة (اختياري)',
  'signup.button': 'تسجيل',
  'signup.loading': 'جاري التسجيل...',
  'signup.login': 'لديك حساب بالفعل؟',
  'signup.login.link': 'تسجيل الدخول',
  'signup.error.passwordMismatch': 'كلمات المرور غير متطابقة',
  'signup.error.default': 'فشل التسجيل، يرجى المحاولة لاحقاً',
  'signup.success': 'تم التسجيل بنجاح',
  'signup.username.rule.length': 'يجب أن يكون اسم المستخدم بين 4 و 10 أحرف',
  'signup.username.rule.format': 'يُسمح فقط بالحروف والأرقام والشرطات السفلية والواصلات',
  'signup.password.rule.length': 'يجب أن تكون كلمة المرور بين 6 و 20 حرفاً',
  'signup.password.rule.lowercase': 'يجب أن تحتوي على أحرف صغيرة',
  'signup.password.rule.uppercase': 'يجب أن تحتوي على أحرف كبيرة',
  'signup.password.rule.number': 'يجب أن تحتوي على أرقام',
  'signup.password.rule.special': 'يجب أن تحتوي على رموز خاصة',
  'resetPassword.page.title': 'إعادة تعيين كلمة المرور - AIMATEX',
  'resetPassword.page.description': 'إعادة تعيين كلمة مرور حسابك في AIMATEX',
  'resetPassword.title': 'إعادة تعيين كلمة المرور',
  'resetPassword.email.placeholder': 'أدخل عنوان بريدك الإلكتروني',
  'resetPassword.code.placeholder': 'أدخل رمز التحقق',
  'resetPassword.password.placeholder': 'أدخل كلمة المرور الجديدة',
  'resetPassword.button': 'إعادة تعيين',
  'resetPassword.button.loading': 'جاري إعادة التعيين...',
  'resetPassword.backToLogin': 'العودة إلى تسجيل الدخول',
  'resetPassword.sendCode': 'الحصول على الرمز',
  'resetPassword.sendCode.sending': 'جاري الإرسال...',
  'resetPassword.sendCode.retry': 'أعد المحاولة بعد {seconds} ثانية',
  'resetPassword.error.emailRequired': 'الرجاء إدخال عنوان بريدك الإلكتروني',
  'resetPassword.error.codeRequired': 'الرجاء إدخال رمز التحقق',
  'resetPassword.error.passwordRequired': 'الرجاء إدخال كلمة المرور الجديدة',
  'resetPassword.error.passwordLength': 'يجب أن تكون كلمة المرور بين 6 و 20 حرفاً',
  'resetPassword.error.codeLength': 'يجب أن يتكون رمز التحقق من 6 أرقام',
  'resetPassword.success.codeSent': 'تم إرسال رمز التحقق إلى بريدك الإلكتروني',
  'resetPassword.success.reset': 'تم إعادة تعيين كلمة المرور بنجاح',
  'resetPassword.error.sendFailed': 'فشل في إرسال رمز التحقق، يرجى المحاولة لاحقاً',
  'resetPassword.error.resetFailed': 'فشل في إعادة تعيين كلمة المرور، يرجى المحاولة لاحقاً',
  'resetPassword.error.incomplete': 'يرجى ملء جميع الحقول المطلوبة',
  'resetPassword.subtitle': 'أدخل عنوان بريدك الإلكتروني وكلمة مرور جديدة لإعادة تعيين الوصول إلى حسابك.',
  'resetPassword.email.label': 'البريد الإلكتروني',
  'resetPassword.code.label': 'رمز التحقق',
  'resetPassword.password.label': 'كلمة المرور الجديدة',
  'resetPassword.success.title': 'تم إعادة التعيين بنجاح',
  'resetPassword.success.description': 'تم تحديث كلمة المرور الخاصة بك بنجاح. يمكنك الآن تسجيل الدخول بكلمة المرور الجديدة.',
  'resetPassword.goToLogin': 'تسجيل الدخول',
  'resetPassword.promo.title': 'احمِ حسابك، واحفظ إبداعك.',
  'resetPassword.promo.description': 'نحن ننفذ بروتوكولات أمان على مستوى البنوك لضمان بقاء بياناتك وإبداعاتك ملكاً لك حصرياً.',
  'signup.verificationCode.placeholder': 'أدخل رمز التحقق',
  'signup.verificationCode.send': 'الحصول على الرمز',
  'signup.verificationCode.sending': 'جاري الإرسال...',
  'signup.verificationCode.retry': 'أعد المحاولة بعد {seconds} ثانية',
  'signup.verificationCode.success': 'تم إرسال رمز التحقق',
  'signup.verificationCode.error': 'فشل في إرسال الرمز',
  'signup.verificationCode.required': 'الرجاء إدخال رمز التحقق',
  'signup.verificationCode.invalid': 'تنسيق رمز التحقق غير صالح',
  'signup.error.emailRequired': 'الرجاء إدخال عنوان بريدك الإلكتروني',
  'signup.announcement': 'وظيفة التسجيل قيد الصيانة اليوم!',
  'sidebar.create': 'إنشاء',
  'sidebar.allFiles': 'جميع الملفات',
  'sidebar.starred': 'المفضلة',
  'sidebar.folders': 'المجلدات',
  'sidebar.trash': 'سلة المهملات',
  'sidebar.decrypt': 'أداة فك التشفير',
  'sidebar.promptMarket': 'سوق المحفزات',
  'sidebar.channels': 'القنوات',
  'sidebar.dailyChallenge': 'التحدي اليومي',
  'sidebar.mediaTools': 'أدوات الوسائط',
  'sidebar.storageNodes': 'عقد التخزين',
  'create.tab.textToImage': 'نص إلى صورة',
  'create.tab.textToVideo': 'نص إلى فيديو',
  'create.tab.imageToImage': 'صورة إلى صورة',
  'create.tab.imageToVideo': 'صورة إلى فيديو',
  'create.tab.seedanceVideo': 'Seedance صورة إلى فيديو',
  'create.seedance.title': 'Seedance صورة إلى فيديو',
  'create.seedance.subtitle': 'ByteDance Doubao Seedance 1.5، إنشاء فيديو قصير مدفوع بالصورة',
  'create.seedance.noModel': 'لا يوجد نموذج Seedance متاح. يرجى التكوين في لوحة الإدارة.',
  'create.seedance.cameraFixed': 'الكاميرا ثابتة',
  'create.seedance.cameraFixed.true': 'نعم (ثابتة)',
  'create.seedance.cameraFixed.false': 'لا (ديناميكية)',
  'create.seedance.watermark': 'إضافة علامة مائية',
  'create.seedance.watermark.true': 'نعم',
  'create.seedance.watermark.false': 'لا',
  'create.textToImage.title': 'نص إلى صورة',
  'create.textToImage.subtitle': 'أدخل وصفاً ودع الذكاء الاصطناعي يرسم الصورة في ذهنك',
  'create.textToImage.description': 'إنشاء صور من أوصاف النص. هذه الميزة قيد التطوير...',
  'create.textToVideo.title': 'نص إلى فيديو',
  'create.textToVideo.subtitle': 'أدخل أوصاف المشاهد وضوابط الكاميرا لإنشاء مقاطع فيديو عالية الجودة',
  'create.textToVideo.description': 'إنشاء مقاطع فيديو من أوصاف النص. هذه الميزة قيد التطوير...',
  'create.imageToImage.title': 'صورة إلى صورة',
  'create.imageToImage.description': 'إنشاء صور جديدة من الصور المرجعية. هذه الميزة قيد التطوير...',
  'create.imageToVideo.title': 'صورة إلى فيديو',
  'create.imageToVideo.description': 'إنشاء مقاطع فيديو من الصور المرجعية. هذه الميزة قيد التطوير...',
  'sidebar.feedback': 'الملاحظات',
  'sidebar.about': 'حول',
  'sidebar.productLog': 'التحديثات',
  'promptMarket.title': 'Prompt Market',
  'promptMarket.subtitle': 'استكشف وصفات الإلهام بالذكاء الاصطناعي من أفضل المبدعين وأطلق إمكاناتك الإبداعية',
  'promptMarket.searchPlaceholder': 'البحث عن المحفزات، الأنماط، النماذج...',
  'promptMarket.search': 'بحث',
  'promptMarket.all': 'الكل',
  'promptMarket.tabAll': 'جميع التوصيات',
  'promptMarket.tabImage': 'نص إلى صورة',
  'promptMarket.tabVideo': 'نص إلى فيديو',
  'promptMarket.tabAudio': 'نص إلى موسيقى',
  'promptMarket.sortLatest': 'الأحدث',
  'promptMarket.sortHot': 'الأكثر شعبية',
  'promptMarket.sortSales': 'الأكثر مبيعاً',
  'promptMarket.publish': 'نشر',
  'promptMarket.empty': 'لا توجد قوائم بعد. كن أول من ينشر!',
  'promptMarket.free': 'مجاني',
  'promptMarket.token': 'TOKEN',
  'promptMarket.loadFailed': 'فشل التحميل',
  'promptMarket.listSuccess': 'تم النشر بنجاح',
  'promptMarket.listFailed': 'فشل النشر',
  'market.label': 'سوق المحفزات',
  'market.h1': 'أطلق',
  'market.h1.highlight': 'ذكاءك الإبداعي.',
  'market.sub': 'الوجهة المميزة لمحفزات الذكاء الاصطناعي: صورة وفيديو وموسيقى. وصفات موثقة تعمل مع OpenAI وGoogle وMidjourney وRunway وKling وLuma وSuno وElevenLabs والمزيد. توقف عن التخمين وابدأ بالإبداع.',
  'market.providers.title': 'يعمل مع النماذج والمنصات الرائدة',
  'market.card1.title': 'تكامل فوري',
  'market.card1.desc': 'تخطَّ منحنى تعلم هندسة المحفزات. استورد محفزات مجربة إلى سير عملك بنقرة واحدة.',
  'market.card2.title': 'استثمر إبداعك',
  'market.card2.desc': 'حوّل أفضل محفزاتك إلى دخل سلبي. انضم إلى آلاف المبدعين الذين يكسبون من خبرتهم في الذكاء الاصطناعي.',
  'market.card3.title': 'جودة موثقة',
  'market.card3.desc': 'كل إدراج يُراجع ويُختبر يدوياً. نضمن نتائج متسقة عبر نماذج مختلفة.',
  'market.card4.title': 'استكشف المختبر',
  'market.card4.desc': 'اكتشف أكثر من 10,000 أصل أنشأها المجتمع.',
  'market.cta': 'فتح سوق المحفزات',
  'home.mediaTools.title': 'أدوات الوسائط',
  'home.mediaTools.subtitle': 'استخدام عبر الإنترنت، بدون تثبيت. معالجة الصور والفيديو والصوت بسهولة.',
  'home.mediaTools.toolSuffix': '',
  'home.mediaTools.imageCompress.title': 'ضغط الصور',
  'home.mediaTools.imageCompress.description': 'ضغط ذكي مع الحفاظ على الجودة. معالجة دفعات مدعومة.',
  'home.mediaTools.videoCompress.title': 'ضغط الفيديو',
  'home.mediaTools.videoCompress.description': 'ضغط فعّال مع دقة ومعدل بت مخصصين. تنسيقات متعددة.',
  'home.mediaTools.audioCompress.title': 'ضغط الصوت',
  'home.mediaTools.audioCompress.description': 'تحسين الحجم مع الحفاظ على الوضوح. MP3 وAAC والمزيد.',
  'filelist.column.name': 'الاسم',
  'filelist.column.size': 'الحجم',
  'filelist.column.updateTime': 'تاريخ التعديل',
  'filelist.column.recycletime': 'تاريخ الحذف',
  'filelist.column.actions': 'الإجراءات',
  'filelist.total': 'إجمالي {total} عنصر',
  'filelist.action.upload': 'رفع',
  'filelist.action.newFolder': 'مجلد جديد',
  'filelist.action.refresh': 'تحديث',
  'filelist.action.search': 'بحث عن الملفات',
  'filelist.action.batchDownload': 'تنزيل',
  'filelist.action.batchDelete': 'حذف',
  'filelist.action.download': 'تنزيل',
  'filelist.action.preview': 'معاينة',
  'filelist.action.rename': 'إعادة تسمية',
  'filelist.selected': 'تم اختيار {count}',
  'page.cloudDrive.title': 'Cloud Drive الخاص بي',
  'page.cloudDrive.description': 'AIMATEX Cloud Drive - قم بتخزين وإدارة ملفاتك بأمان',
  'modal.fileUpload.title': 'رفع الملفات',
  'modal.fileUpload.dragText': 'اسحب الملفات هنا أو انقر للرفع',
  'modal.fileUpload.start': 'بدء الرفع',
  'modal.fileUpload.cancel': 'إلغاء',
  'modal.fileUpload.clear': 'مسح القائمة',
  'modal.fileUpload.encrypt': 'تشفير المحدد',
  'modal.fileUpload.addMore': 'إضافة',
  'modal.fileUpload.remove': 'إزالة',
  'modal.fileUpload.error.noSelection': 'يرجى اختيار الملفات للإزالة',
  'modal.fileUpload.error.noEncryption': 'يرجى اختيار الملفات للتشفير',
  'modal.fileUpload.error.noClear': 'لا توجد ملفات للمسح',
  'modal.fileUpload.error.noStart': 'لا توجد ملفات للرفع',
  'modal.fileUpload.error.noCancel': 'لا توجد عمليات رفع نشطة للإلغاء',
  'modal.fileUpload.error.fileSize': 'تم تجاوز حجم الملف',
  'modal.fileUpload.error.fileType': 'نوع الملف غير مدعوم',
  'modal.fileUpload.error.maxCount': 'تم تجاوز الحد الأقصى لعدد الملفات',
  'modal.fileUpload.duplicate.title': 'الملف موجود بالفعل',
  'modal.fileUpload.duplicate.skip': 'تخطي',
  'modal.fileUpload.duplicate.replace': 'استبدال',
  'modal.fileUpload.duplicate.rename': 'إعادة تسمية',
  'modal.fileUpload.status.pending': 'قيد الانتظار',
  'modal.fileUpload.status.uploading': 'جاري الرفع',
  'modal.fileUpload.status.success': 'تم الإكمال',
  'modal.fileUpload.status.error': 'خطأ',
  'modal.fileUpload.status.cancelled': 'تم الإلغاء',
  'modal.fileUpload.status.duplicated': 'مكرر',
  'modal.fileUpload.table.filename': 'اسم الملف',
  'modal.fileUpload.table.size': 'الحجم',
  'modal.fileUpload.table.status': 'الحالة',
  'modal.fileUpload.table.progress': 'التقدم',
  'modal.fileUpload.table.actions': 'الإجراءات',
  'modal.fileUpload.speed': 'سرعة الرفع',
  'modal.fileUpload.remainingTime': 'الوقت المتبقي',
  'modal.fileUpload.total.progress': 'التقدم الكلي',
  'modal.fileUpload.error.message': 'خطأ في الرفع: {message}',
  'modal.fileUpload.confirm.clear': 'هل تريد مسح قائمة الرفع؟',
  'modal.fileUpload.confirm.cancel': 'هل تريد إلغاء الرفع؟',
  'modal.fileUpload.clear.mobile': 'مسح',
  'modal.fileUpload.encrypt.mobile': 'تشفير',
  'modal.fileUpload.addMore.mobile': 'إضافة',
  'modal.newFolder.title': 'مجلد جديد',
  'modal.newFolder.placeholder': 'أدخل اسم المجلد',
  'modal.newFolder.ok': 'إنشاء',
  'modal.newFolder.cancel': 'إلغاء',
  'filelist.modal.rename.title': 'إعادة تسمية',
  'filelist.modal.rename.placeholder': 'أدخل الاسم الجديد',
  'filelist.modal.rename.ok': 'موافق',
  'filelist.modal.rename.cancel': 'إلغاء',
  'productLog.title': 'تحديثات المنتج',
  'page.decrypt.title': 'أداة فك تشفير الملفات MyStorage',
  'page.decrypt.subtitle': 'قم بفك تشفير ملفاتك بأمان',
  'page.decrypt.helmet.title': 'أداة فك التشفير - MyStorage',
  'page.decrypt.helmet.description': 'أداة فك تشفير آمنة - قم بفك تشفير ملفاتك محلياً في المتصفح لحماية خصوصيتك',
  'decrypt.upload.dragText': 'انقر أو اسحب الملفات',
  'decrypt.upload.hint': 'يدعم ملفات .encrypted، الحد الأقصى {maxSize} لكل ملف',
  'decrypt.upload.button.decrypt': 'فك تشفير المحدد',
  'decrypt.upload.button.clear': 'مسح القائمة',
  'decrypt.fileList.empty': 'لا توجد ملفات، يرجى إضافة ملفات لفك تشفيرها',
  'decrypt.fileList.column.name': 'اسم الملف',
  'decrypt.fileList.column.size': 'الحجم',
  'decrypt.fileList.column.status': 'الحالة',
  'decrypt.fileList.column.actions': 'الإجراءات',
  'decrypt.fileList.status.pending': 'قيد الانتظار',
  'decrypt.fileList.status.decrypting': 'جاري فك التشفير',
  'decrypt.fileList.status.success': 'تم الإكمال',
  'decrypt.fileList.status.error': 'خطأ',
  'decrypt.fileList.action.info': 'معلومات',
  'decrypt.password.modal.title': 'أدخل كلمة مرور فك التشفير',
  'decrypt.password.modal.placeholder': 'أدخل كلمة المرور',
  'decrypt.password.modal.hint': 'أدخل كلمة المرور التي تم تعيينها أثناء التشفير، سيتم استخدامها فقط لفك التشفير المحلي',
  'decrypt.security.modal.title': 'إشعار الأمان',
  'decrypt.security.modal.description': 'تتم جميع عمليات فك التشفير محلياً، لن يتم إرسال كلمة المرور ومحتوى الملف إلى الخادم أبداً',
  'decrypt.security.modal.vip.title': 'كمستخدم VIP، يمكنك:',
  'decrypt.security.modal.vip.feature1': 'فك تشفير الملفات من أي حجم',
  'decrypt.security.modal.vip.feature2': 'استخدام فك التشفير الذكي بالكتل لكفاءة أفضل',
  'decrypt.security.modal.vip.feature3': 'دعم فك تشفير دفعي للملفات الكبيرة',
  'decrypt.security.modal.free.title': 'هام: تتطلب عملية فك التشفير حوالي 3 أضعاف حجم الملف في ذاكرة المتصفح.',
  'decrypt.security.modal.free.feature1': 'المستخدمون المجانيون محدودون بـ 4GB لكل ملف',
  'decrypt.security.modal.free.feature2': 'قم بالترقية إلى VIP لفك تشفير الملفات من أي حجم',
  'decrypt.security.modal.free.feature3': 'إذا تعطل المتصفح، فكر في الترقية إلى VIP لاستخدام فك التشفير بالكتل',
  'decrypt.message.invalidFile': 'يرجى اختيار ملفات .encrypted فقط',
  'decrypt.message.duplicate': 'الملف "{filename}" موجود بالفعل، تمت إزالة النسخة المكررة تلقائياً',
  'decrypt.message.oversizeTitle': 'تم تجاوز حجم الملف',
  'decrypt.message.oversizeContent': 'الملفات التالية تتجاوز الحد المجاني (4GB):',
  'decrypt.message.oversizeHint': 'قم بالترقية إلى VIP لفك تشفير الملفات من أي حجم',
  'decrypt.message.selectFile': 'يرجى اختيار الملفات لفك تشفيرها',
  'decrypt.message.enterPassword': 'يرجى إدخال كلمة مرور فك التشفير',
  'decrypt.message.decryptSuccess': 'تم حفظ الملف {filename}',
  'decrypt.message.saveCancel': 'تم إلغاء حفظ الملف {filename}',
  'decrypt.message.downloadSuccess': 'تم حفظ الملف {filename} في مجلد التنزيلات',
  'decrypt.message.decryptError': 'خطأ في فك تشفير الملف {filename}: {error}',
  'decrypt.message.batchError': 'فشل فك التشفير الدفعي، يرجى المحاولة مرة أخرى',
  'security.features.title': 'ميزات الأمان',
  'security.features.localDecryption.title': 'فك التشفير المحلي',
  'security.features.localDecryption.description': 'تتم جميع عمليات فك التشفير محلياً في متصفحك، لا يغادر محتوى الملف وكلمة المرور جهازك أبداً',
  'security.features.militaryEncryption.title': 'تشفير عسكري',
  'security.features.militaryEncryption.description': 'يستخدم خوارزمية تشفير AES-256-CBC، معيار التشفير المتماثل الأكثر أماناً الذي يمكنه مقاومة جميع الهجمات المعروفة',
  'security.features.privacyProtection.title': 'حماية الخصوصية',
  'security.features.privacyProtection.description': 'آلية صارمة لحماية الخصوصية، لا يتم حفظ كلمات مرور فك التشفير، لا يتم تسجيل محتوى الملفات',
  'security.features.smartDecryption.title': 'فك التشفير الذكي بالكتل',
  'security.features.smartDecryption.description': 'تقنية فك التشفير الذكي بالكتل تحسن سرعة فك التشفير بشكل كبير مع تقليل استخدام الذاكرة',
  'security.features.learnMore': 'معرفة المزيد',
  'security.diagram.plaintext.block1': 'كتلة النص العادي 1',
  'security.diagram.plaintext.block2': 'كتلة النص العادي 2',
  'security.diagram.ciphertext.block1': 'كتلة النص المشفر 1',
  'security.diagram.ciphertext.block2': 'كتلة النص المشفر 2',
  'security.diagram.key': 'المفتاح',
  'security.diagram.aes.encryption': 'تشفير AES',
  'security.diagram.xor.operation': 'عملية XOR',
  'security.diagram.iv': 'متجه التهيئة',
  'common.unknown': 'غير معروف',
  'common.philosophy': 'يجب أن تخدم التكنولوجيا الشعب',
  'common.speed': 'السرعة',
  'common.timeSpent': 'الوقت المستغرق',
  'common.remaining': 'المتبقي',
  'sideMenu.storageInfo.title': 'مساحة التخزين',
  'sideMenu.storageInfo.usage': 'مستخدم {used} / الإجمالي {total}',
  'sideMenu.storageStats.title': 'إحصائيات التخزين',
  'sideMenu.storageStats.overview': 'نظرة عامة',
  'sideMenu.storageStats.totalFiles': 'إجمالي الملفات',
  'sideMenu.storageStats.totalSize': 'الحجم الإجمالي',
  'sideMenu.storageStats.fileTypes': 'توزيع أنواع الملفات',
  'sideMenu.storageStats.providers': 'مزودي الخدمة',
  'common.default': 'افتراضي',
  'common.regionCode': 'رمز المنطقة',
  'common.nodeType': 'نوع العقدة',
  'common.storageUsed': 'المساحة المستخدمة',
  'common.storageAvailable': 'المساحة المتاحة',
  'common.storageLimit': 'السعة الإجمالية',
  'common.storageUsageDetail': 'مستخدم {used} / الإجمالي {total}',
  'common.defaultNode': 'العقدة الافتراضية',
  'common.confirm': 'تأكيد',
  'common.cancel': 'إلغاء',
  'common.latency': 'زمن الاستجابة',
  'common.retry': 'إعادة المحاولة',
  'cloudDrive.nodeSelect.title': 'اختيار عقدة التخزين',
  'cloudDrive.nodeSelect.addNode': 'إضافة عقدة تخزين',
  'cloudDrive.nodeSelect.deleteConfirm.title': 'تأكيد حذف العقدة',
  'cloudDrive.nodeSelect.deleteConfirm.content': 'هل أنت متأكد من حذف العقدة "{nodeName}"؟ لا يمكن التراجع عن هذا الإجراء!',
  'cloudDrive.nodeSelect.deleteSuccess': 'تم حذف العقدة بنجاح',
  'cloudDrive.nodeSelect.deleteFailed': 'فشل حذف العقدة',
  
  // إنشاء العقدة
  'cloudDrive.nodeCreate.title': 'إضافة عقدة تخزين',
  'cloudDrive.nodeCreate.selectProvider': 'اختر مزود السحابة',
  'cloudDrive.nodeCreate.nodeName': 'اسم العقدة',
  'cloudDrive.nodeCreate.nodeNamePlaceholder': 'اترك فارغاً لاستخدام الاسم الافتراضي',
  'cloudDrive.nodeCreate.nameMaxLength': 'لا يمكن أن يتجاوز اسم العقدة 50 حرفاً',
  'cloudDrive.nodeCreate.noProviders': 'لا يوجد مزودي سحابة متاحين',
  'cloudDrive.nodeCreate.pingLatency': 'زمن الاستجابة {value} مللي ثانية',
  'cloudDrive.nodeCreate.pingTesting': 'جارٍ اختبار زمن الاستجابة...',
  'cloudDrive.nodeCreate.pingFailed': 'فشل اختبار زمن الاستجابة',
  'cloudDrive.nodeCreate.pingUnavailable': 'اختبار زمن الاستجابة غير متاح',
  'cloudDrive.nodeCreate.sortByLatency': 'ترتيب حسب زمن الاستجابة',
  'cloudDrive.nodeCreate.selectRegion': 'اختيار المنطقة',
  'cloudDrive.nodeCreate.selectedRegion': 'المنطقة المحددة',
  'cloudDrive.nodeCreate.noRegions': 'لا توجد مناطق متاحة',
  'cloudDrive.nodeCreate.selectProviderPlaceholder': 'يرجى اختيار مزود السحابة',
  'cloudDrive.nodeCreate.selectProviderRequired': 'يرجى اختيار مزود السحابة أولاً',
  'cloudDrive.nodeCreate.selectRegionRequired': 'يرجى اختيار المنطقة أولاً',
  'cloudDrive.nodeCreate.loadProvidersFailed': 'فشل تحميل قائمة مزودي السحابة',
  'cloudDrive.nodeCreate.loadRegionsFailed': 'فشل تحميل قائمة المناطق',
  'cloudDrive.nodeCreate.nodeType': 'نوع العقدة',
  'cloudDrive.nodeCreate.nodeType.standard': 'تخزين قياسي',
  'cloudDrive.nodeCreate.nodeType.lowFreq': 'تخزين منخفض التردد',
  'cloudDrive.nodeCreate.nodeType.archive': 'تخزين الأرشيف',
  'cloudDrive.nodeCreate.storageLimit': 'حد التخزين',
  'cloudDrive.nodeCreate.storageLimitRequired': 'يرجى إدخال حد التخزين',
  'cloudDrive.nodeCreate.storageLimitMin': 'لا يمكن أن يكون حد التخزين أقل من 1 جيجابايت',
  'cloudDrive.nodeCreate.storageLimitPlaceholder': 'أدخل حد التخزين (جيجابايت)',
  'cloudDrive.nodeCreate.success': 'تم إنشاء عقدة التخزين بنجاح',
  'cloudDrive.nodeCreate.failed': 'فشل إنشاء عقدة التخزين',
  
  // تحرير العقدة
  'cloudDrive.nodeEdit.title': 'تحرير العقدة',
  'cloudDrive.nodeEdit.name': 'اسم العقدة',
  'cloudDrive.nodeEdit.nameRequired': 'يرجى إدخال اسم العقدة',
  'cloudDrive.nodeEdit.nameMaxLength': 'لا يمكن أن يتجاوز اسم العقدة 50 حرفاً',
  
  // TextToImage page internationalization
  'create.prompt': 'المطالبة',
  'create.prompt.placeholder': 'مثال: قطة سايبربانك تمشي في الفضاء، خلفية نيون، تفاصيل عالية...',
  'create.prompt.required': 'يرجى إدخال المطالبة',
  'create.prompt.generate': 'ذكاء اصطناعي توليد المطالبة',
  'create.prompt.enrich': 'ذكاء اصطناعي إثراء المطالبة',
  'create.prompt.generate.success': 'تم توليد المطالبة بنجاح!',
  'create.prompt.generate.error': 'فشل توليد المطالبة، يرجى المحاولة مرة أخرى',
  'create.prompt.generate.empty': 'لم يتم توليد مطالبة، يرجى المحاولة مرة أخرى',
  'create.prompt.restore': 'استعادة',
  'create.prompt.restore.success': 'تمت الاستعادة إلى المطالبة الأصلية',
  'create.prompt.restore.tooltip': 'استعادة إلى المطالبة قبل توليد/إثراء الذكاء الاصطناعي',
  'create.negativePrompt': 'المطالبة السلبية',
  'create.ratio': 'نسبة العرض إلى الارتفاع',
  'create.style': 'النمط الفني',
  'create.batchSize': 'عدد التوليدات',
  'create.generate': 'توليد الآن',
  'create.negativePrompt.tooltip': 'العناصر التي لا تريدها في الصورة',
  'create.negativePrompt.placeholder': 'مثال: ضبابية، جودة منخفضة، أصابع مشوهة...',
  'create.generating': 'جارٍ التوليد...',
  'create.generating.waiting': 'الذكاء الاصطناعي يبدع، يرجى الانتظار...',
  'create.result.title': 'النتائج المولدة',
  'create.downloadAll': 'تحميل الكل',
  'create.aspectRatio.1:1': '1:1 (مربع)',
  'create.aspectRatio.16:9': '16:9 (أفقي)',
  'create.aspectRatio.9:16': '9:16 (عمودي)',
  'create.aspectRatio.21:9': '21:9 (سينما)',
  'create.aspectRatio.4:3': '4:3 (كلاسيكي)',
  'create.style.general': 'عام',
  'create.style.anime': 'أنيمي',
  'create.style.realistic': 'واقعي',
  'create.style.3d-render': '3D Render',
  'create.style.cyberpunk': 'سايبربانك',
  'create.settings.loadFailed': 'فشل تحميل إعدادات نوع الإبداع، عرض جميع الخيارات',
  'create.settings.error': 'فشل تحميل الإعدادات، عرض جميع الخيارات',
  'create.noAvailableTabs': 'لا توجد أنواع إبداع متاحة',
  'create.network.error.title': 'خطأ في اتصال الشبكة',
  'create.network.error.description': 'تعذر تحميل إعدادات نوع الإبداع. يرجى التحقق من اتصال الشبكة وتحديث الصفحة',
  'create.network.error.refresh': 'تحديث الصفحة',
  
  // TextToVideo page internationalization
  'create.prompt.video': 'وصف مشهد الفيديو (Prompt)',
  'create.prompt.video.placeholder': 'مثال: كلب رائد فضاء يرقص على سطح القمر، 8K، إضاءة سينمائية، سريالية.',
  'create.prompt.video.required': 'يرجى إدخال وصف مشهد الفيديو',
  'create.generate.video': 'إنشاء الفيديو الآن',
  'create.video.ratio': 'نسبة العرض إلى الارتفاع',
  'create.video.camera': 'حركة الكاميرا',
  'create.video.duration': 'مدة الفيديو (ثانية)',
  'create.video.format': 'تنسيق الإخراج',
  'create.cameraMotion.none': 'بدون حركة (None)',
  'create.cameraMotion.zoomIn': 'تكبير (Zoom In)',
  'create.cameraMotion.dollyOut': 'إبعاد (Dolly Out)',
  'create.cameraMotion.panLeft': 'تحريك لليسار (Pan Left)',
  'create.cameraMotion.tiltUp': 'إمالة لأعلى (Tilt Up)',
  'create.cameraMotion.orbital': '360° مدارية (Orbital)',
  'create.negativePrompt.video.placeholder': 'مثال: علامات مائية، وميض، دقة منخفضة، شخصيات ضبابية...',
  'create.sora.thinking': 'Sora يفكر...',
  'create.video.analyzing': 'جارٍ تحليل الصورة والمطالبة، الذكاء الاصطناعي يقوم بإنشاء...',
  'create.video.info': 'المدة: {duration}ث | النسبة: {ratio}',
  'create.video.preview': 'معاينة الفيديو',
  'create.video.result': 'معاينة الفيديو النهائية',
  'create.video.empty': 'ستظهر النتائج المولدة هنا',
  'create.download': 'تحميل الفيديو',
  'create.duration.format': '{duration}ث',
  'create.duration.4s': '4ث',
  'create.duration.8s': '8ث',
  'create.duration.15s': '15ث',
  'create.estimated.price': 'التقدير: {price}',
  'create.model.select': 'اختر النموذج',
  'create.model.loading': 'جارٍ تحميل النماذج...',
  'create.model.loadFailed': 'فشل تحميل قائمة النماذج',
  'create.model.family.select': 'اختر عائلة النموذج',
  'create.model.family.select.placeholder': 'يرجى اختيار عائلة النموذج',
  'create.model.family.loadFailed': 'فشل تحميل قائمة عائلات النماذج',
  'create.style.select.placeholder': 'يرجى اختيار النمط الفني (اختياري، افتراضيًا يستخدم نموذج العائلة)',
  'create.model.style.loadFailed': 'فشل تحميل قائمة نماذج الأنماط',
  'create.model.description': 'وصف النموذج',
  'create.model.aspectResolution': 'دقة النسبة',
  'create.model.fps': 'معدل الإطارات',
  'create.model.features': 'الميزات المدعومة',
  'create.model.feature.cameraMotion': 'حركة الكاميرا',
  'create.model.feature.img2video': 'صورة إلى فيديو',
  'create.model.feature.videoEdit': 'تحرير الفيديو',
  'create.model.price.perSecond': '/ثانية',
  'create.model.detail': 'التفاصيل',
  'create.history.title': 'سجل التوليد',
  'create.history.refresh': 'تحديث',
  'create.history.empty': 'لا يوجد سجل توليد',
  'create.history.total': 'إجمالي {total} سجل',
  'create.history.status.queued': 'في الانتظار',
  'create.history.status.processing': 'قيد المعالجة',
  'create.history.status.success': 'نجح',
  'create.history.status.failed': 'فشل',
  'create.history.status.timeout': 'انتهت المهلة',
  'create.history.failed.noImage': 'فشل التوليد',
  'create.history.downloadAll.start': 'بدء تنزيل {count} صورة',
  'create.history.downloadAll.tooltip': 'تنزيل جميع {count} صورة',
  'create.history.download.tooltip': 'تنزيل الصورة',
  'create.history.detail.tooltip': 'عرض التفاصيل',
  'create.history.noPrompt': 'لا يوجد وصف',
  'create.history.deleteConfirm.title': 'تأكيد الحذف',
  'create.history.deleteConfirm.content': 'هل أنت متأكد من حذف هذه المهمة؟ لا يمكن التراجع عن هذا الإجراء.',
  'create.history.deleteSuccess': 'تم الحذف بنجاح',
  'create.history.deleteFailed': 'فشل الحذف',
  'create.taskDetail.title': 'تفاصيل المهمة',
  'create.taskDetail.loading': 'جاري التحميل...',
  'create.taskDetail.loadFailed': 'فشل تحميل تفاصيل المهمة',
  'create.taskDetail.noData': 'لا توجد بيانات متاحة',
  'create.taskDetail.basicInfo': 'المعلومات الأساسية',
  'create.taskDetail.model': 'النموذج',
  'create.taskDetail.taskType': 'نوع المهمة',
  'create.taskDetail.createTime': 'وقت الإنشاء',
  'create.taskDetail.duration': 'مدة التوليد',
  'create.taskDetail.prompt': 'الموجه',
  'create.taskDetail.error': 'رسالة الخطأ',
  'create.taskDetail.outputFiles': 'ملفات الإخراج',
  'create.taskDetail.downloadAll': 'تنزيل الكل',
  'create.taskDetail.downloadAll.start': 'بدء تنزيل {count} صورة',
  'create.taskDetail.modelInfo': 'معلومات النموذج',
  'create.taskDetail.defaultResolution': 'الدقة الافتراضية',
  'create.taskDetail.maxResolution': 'أقصى دقة',
  'create.taskDetail.aspectRatios': 'نسب العرض المدعومة',
  'create.taskDetail.formats': 'التنسيقات المدعومة',
  'create.taskDetail.prompt.copied': 'تم نسخ الموجه',
  'create.taskDetail.liked': 'تم الإعجاب',
  'create.taskDetail.like': 'إعجاب',
  'create.taskDetail.collected': 'تم الحفظ',
  'create.taskDetail.collect': 'حفظ',
  'create.taskDetail.linkCopied': 'تم نسخ الرابط',
  'create.taskDetail.share': 'مشاركة',
  'create.taskDetail.outputs': 'المخرجات',
  'create.taskDetail.preview': 'معاينة',
  'create.taskDetail.download': 'تنزيل',
  'create.taskDetail.generationFailed': 'فشل التوليد',
  'create.taskDetail.generating': 'جاري التوليد...',
  'create.taskDetail.promptLabel': 'الموجه',
  'create.taskDetail.copy': 'نسخ',
  'create.taskDetail.executionStats': 'إحصائيات التنفيذ',
  'create.taskDetail.creditsCost': 'تكلفة الرصيد',
  'create.taskDetail.modelSpecs': 'مواصفات النموذج',
  'create.taskDetail.capabilities': 'القدرات',
  'create.taskDetail.supportedRatios': 'النسب المدعومة',
  'create.taskDetail.dataError': 'خطأ في البيانات',
  'create.taskDetail.more': 'المزيد',
  'create.taskDetail.downloading': 'جاري التنزيل...',
  'create.taskDetail.points': 'نقطة',
  'create.taskDetail.seconds': 'ث',
  'create.taskDetail.status.success': 'نجح',
  'create.taskDetail.status.failed': 'فشل',
  'create.taskDetail.status.processing': 'قيد المعالجة',
  'create.taskDetail.status.queued': 'في الانتظار',
  'create.taskDetail.status.generating': 'قيد الإنشاء',
  'create.taskDetail.durationLabel': 'المدة',
  'create.taskDetail.taskParams': 'معاملات المهمة',
  'create.taskDetail.aspectRatio': 'نسبة العرض إلى الارتفاع',
  'create.taskDetail.inputType': 'نوع الإدخال',
  'create.taskDetail.modelCode': 'رمز النموذج',
  'create.taskDetail.regenerate': 'إعادة الإنشاء',
  'create.taskDetail.feature.developing': 'الميزة قيد التطوير',
  'create.taskDetail.result': 'نتيجة الإنشاء',
  'create.taskDetail.copyPrompt': 'نسخ المطالبة',
  'create.taskDetail.imageDimensions': 'الأبعاد',
  'create.taskDetail.fileSize': 'حجم الملف',
  'create.taskDetail.loadingImageInfo': 'جارٍ تحميل معلومات الصورة...',
  'create.history.failed.noVideo': 'فشل الإنشاء',
  'create.video.generate.cancelled.polling': 'تم إلغاء استطلاع المهمة',
  'create.video.generate.queued': 'تم إرسال مهمة إنشاء الفيديو، في قائمة الانتظار...',
  'create.video.generate.noUrl': 'اكتمل إنشاء الفيديو، ولكن لم يتم العثور على رابط الفيديو',
  'create.video.status.checkFailed': 'فشل التحقق من حالة المهمة',
  'create.video.generate.processing': 'تم إرسال مهمة إنشاء الفيديو، قيد المعالجة...',
  'create.video.taskQueue': 'قائمة انتظار المهام',
  'create.video.polling': 'جارٍ إنشاء الفيديو، يرجى الانتظار...',
  'create.video.ratio.invalid': 'يرجى اختيار نسبة عرض إلى ارتفاع للفيديو مدعومة من النموذج',
  'create.waitingTask.queue': 'قائمة انتظار المهام',
  'create.waitingTask.empty': 'لا توجد مهام قيد التنفيذ',
  'create.waitingTask.generating': 'قيد الإنشاء...',
  'create.waitingTask.queued': 'في قائمة الانتظار',
  'create.waitingTask.cancel': 'إلغاء المهمة',
  // HistorySection تدويل جديد
  'create.history.copyPrompt': 'نسخ المطالبة',
  'create.history.download': 'تحميل',
  'create.history.delete': 'حذف',
  'create.history.generating': 'قيد الإنشاء...',
  'create.history.generationFailed': 'فشل الإنشاء',
  'create.history.noPreview': 'لا يوجد معاينة',
  // ImageToVideo تدويل جديد
  'create.i2v.fileType.error': 'يرجى اختيار ملف صورة',
  'create.i2v.fileSize.error': 'لا يمكن أن يتجاوز حجم ملف الصورة 10 ميجابايت',
  'create.i2v.imageSize.error': 'يجب أن يكون ارتفاع الصورة على الأقل {minHeight} بكسل، الحجم الحالي للصورة هو {width}x{height} بكسل',
  'create.i2v.fileRead.error': 'فشل قراءة الصورة',
  'create.i2v.replaceImage': 'استبدال الصورة',
  'create.i2v.upload.supportedFormats': 'يدعم JPG و PNG و WebP و JFIF',
  'create.i2v.upload.required': 'يرجى تحميل صورة مرجعية',
  'create.i2v.upload': 'تحميل الصورة المرجعية (الإطار الأول)',
  'create.i2v.upload.click': 'انقر أو اسحب للتحميل',
  'create.i2v.prompt.required': 'يرجى إدخال وصف إرشادي للحركة',
  'create.i2v.uploading.image': 'جارٍ تحميل الصورة إلى السحابة...',
  'create.i2v.upload.success': 'تم تحميل الصورة بنجاح',
  'create.i2v.upload.failed': 'فشل تحميل الصورة، يرجى المحاولة مرة أخرى',
  'create.i2v.original': 'الأصل (الإطار الأول)',
  'create.i2v.result': 'مقارنة الإنشاء',
  'create.i2v.empty': 'سيتم عرض مقارنة النتائج المولدة والصورة الأصلية هنا',
  'create.generate.i2v': 'بدء إنشاء الفيديو',
  'create.prompt.i2v.placeholder': 'مثال: جعل الشخص في الصورة يبدأ المشي، أوراق الخلفية تتأرجح في الريح...',
  'create.prompt.enhance.tooltip': 'إثراء المطالبة بالذكاء الاصطناعي لجعل الوصف أكثر تفصيلاً وحيوية',
  'create.prompt.enhance': 'إثراء بالذكاء الاصطناعي',
  'create.prompt.enhance.empty': 'يرجى إدخال مطالبة أساسية أولاً',
  'create.prompt.enhance.success': 'تم إثراء المطالبة بنجاح!',
  'create.prompt.enhance.empty.result': 'لم يتم إنشاء مطالبة مُثراة، يرجى المحاولة مرة أخرى',
  'create.prompt.enhance.error': 'فشل إثراء المطالبة، يرجى المحاولة مرة أخرى',
  'create.prompt.version.history': 'سجل الإصدارات',
  'create.prompt.version.history.tooltip': 'عرض سجل إصدارات المطالبة',
  // TaskDetailModal تدويل جديد
  'create.taskDetail.unnamedTask': 'مهمة بدون اسم',
  'create.taskDetail.prompt.title': 'المطالبة',
  'create.taskDetail.tokenCost': 'تكلفة الرمز المميز',
  'create.taskDetail.publish': 'نشر في المجتمع',
  'create.taskDetail.selectCover': 'اختر الغلاف',
  'create.taskDetail.selectChannel': 'اختر القناة',
  'create.taskDetail.selectChallenge': 'اختر التحدي',
  'create.taskDetail.publishSuccess': 'تم النشر بنجاح',
  'create.taskDetail.loadChannelsFailed': 'فشل تحميل القنوات',
  'create.taskDetail.loadChallengesFailed': 'فشل تحميل التحديات',
  'create.taskDetail.publishFailed': 'فشل النشر',
  'create.taskDetail.daysLeft': 'متبقي {days} يوم',
  // ModelDetailModal تدويل جديد
  'create.model.capability.t2v': 'T2V (نص إلى فيديو)',
  'create.model.capability.img2video': 'صورة إلى فيديو',
  'create.model.capability.videoEdit': 'تحرير الفيديو',
  'create.model.capability.characterConsistency': 'اتساق الشخصية',
  'create.model.capability.reference': 'مرجع',
  'create.model.capability.cameraMotion': 'حركة الكاميرا',
  'create.model.aspectRatios': 'نسب العرض',
  'create.model.resolution': 'الدقة',
  'create.model.resolution.default': 'افتراضي',
  'create.model.resolution.max': 'الحد الأقصى',
  'create.model.duration': 'المدة',
  'create.model.formats': 'التنسيقات',
  'create.model.like': 'إعجاب',
  'create.model.liked': 'تم الإعجاب',
  'create.model.unliked': 'تم إلغاء الإعجاب',
  'create.model.favorite': 'مفضل',
  'create.model.favorited': 'تمت الإضافة إلى المفضلة',
  'create.model.unfavorited': 'تمت الإزالة من المفضلة',
  'create.model.share': 'مشاركة',
  'create.model.linkCopied': 'تم نسخ الرابط',
  'create.model.capabilities': 'القدرات',
  'create.model.free': 'مجاني',
  'create.model.tokenCost.display': '{count} token',
  // مفاتيح جديدة أخرى
  'create.aspectRatio.portrait': 'عمودي',
  'create.aspectRatio.landscape': 'أفقي',
  'create.video.ratio.placeholder': 'يرجى اختيار نسبة عرض الفيديو',
  'create.video.format.placeholder': 'يرجى اختيار تنسيق الإخراج',
  'create.video.style': 'نمط الفيديو',
  'create.video.style.tooltip': 'اختر نمط إنشاء الفيديو',
  'create.video.style.placeholder': 'يرجى اختيار نمط الفيديو',
  'create.video.quality': 'جودة الفيديو',
  'create.video.quality.tooltip': 'اختر جودة إنشاء الفيديو',
  'create.video.quality.placeholder': 'يرجى اختيار جودة الفيديو',
  'create.duration.select.placeholder': 'يرجى اختيار مدة الفيديو',
  'create.model.select.placeholder': 'يرجى اختيار نموذج أولاً',
  'video.not.supported': 'المتصفح الخاص بك لا يدعم تشغيل الفيديو.',
  // UnderDevelopment التدويل
  'underDevelopment.comingSoon': 'قريباً',
  'underDevelopment.title': 'الميزة قيد التطوير',
  'underDevelopment.subtitle': 'نعمل بجد على تطوير هذه الميزة، يرجى البقاء على اطلاع!',
  'underDevelopment.backHome': 'العودة إلى الصفحة الرئيسية',
  'underDevelopment.goBack': 'رجوع',
  // UserMenu التدويل
  'userMenu.email.notBound': 'البريد الإلكتروني غير مرتبط',
  'userMenu.status.verified': 'تم التحقق',
  'userMenu.status.guest': 'ضيف',
  'userMenu.recharge': 'إعادة الشحن الآن',
  'userMenu.community': 'المجتمع',
  'userMenu.group.account': 'إعدادات الحساب',
  'userMenu.group.assets': 'الأصول والطلبات',
  'userMenu.group.workspace': 'مساحة العمل',
  'userMenu.group.support': 'الدعم',
  'userMenu.item.profile': 'الملف الشخصي',
  'userMenu.item.settings': 'الإعدادات',
  'userMenu.item.security': 'الأمان',
  'userMenu.item.privacy': 'الخصوصية',
  'userMenu.item.wallet': 'محفظتي',
  'userMenu.item.subscription': 'الاشتراك',
  'userMenu.item.orders': 'سجل الطلبات',
  'userMenu.item.works': 'أعمالي',
  'userMenu.item.notifications': 'الإشعارات',
  'userMenu.item.help': 'مركز المساعدة',
  'userMenu.item.invite': 'دعوة الأصدقاء',
  'userMenu.item.feedback': 'الملاحظات',
  'userMenu.item.about': 'معلومات عنا',
  'userMenu.level': 'المستوى',
  'userMenu.member.vip1': 'عضو أساسي',
  'userMenu.member.vip2': 'عضو فضي',
  'userMenu.member.vip3': 'عضو ذهبي',
  'userMenu.member.vip4': 'عضو ماسي',
  'userMenu.member.vip5': 'عضو نهائي',
  'userMenu.logout': 'تسجيل الخروج',
  // Recharge Agreement التدويل
  'rechargeAgreement.back': 'رجوع',
  'rechargeAgreement.title': 'اتفاقية خدمة إعادة الشحن',
  'rechargeAgreement.lastUpdated': 'آخر تحديث: ',
  'rechargeAgreement.goRecharge': 'الذهاب إلى إعادة الشحن',
  'rechargeAgreement.section1.title': 'أولاً: نطاق الاتفاقية',
  'rechargeAgreement.section1.content1': 'هذه الاتفاقية هي اتفاقية قانونية بينك وبين المنصة فيما يتعلق بخدمات إعادة الشحن. قبل استخدام خدمة إعادة الشحن، يرجى قراءة جميع محتويات هذه الاتفاقية بعناية. إذا لم توافق على أي محتوى من هذه الاتفاقية، أو لا يمكنك فهم معنى الشروط ذات الصلة بدقة، يرجى عدم إجراء عمليات إعادة الشحن.',
  'rechargeAgreement.section1.content2': 'بالنقر على "موافق" أو إجراء عمليات إعادة الشحن، فإنك تشير إلى أنك قرأت وفهمت ووافقت على جميع محتويات هذه الاتفاقية.',
  'rechargeAgreement.section2.title': 'ثانياً: تعليمات إعادة الشحن',
  'rechargeAgreement.section2.subtitle1': '2.1 طرق إعادة الشحن',
  'rechargeAgreement.section2.content1': 'تدعم المنصة طرق إعادة الشحن التالية:',
  'rechargeAgreement.section2.method1': 'Alipay',
  'rechargeAgreement.section2.method2': 'WeChat Pay',
  'rechargeAgreement.section2.method3': 'البطاقة المصرفية (UnionPay, Visa, MasterCard)',
  'rechargeAgreement.section2.method4': 'عملة USDT المشفرة (ERC20/TRC20)',
  'rechargeAgreement.section2.subtitle2': '2.2 عملة إعادة الشحن',
  'rechargeAgreement.section2.content2': 'تدعم المنصة إعادة الشحن بالعملات التالية: CNY, USD, USDT. قد يكون هناك تحويل سعر صرف بين العملات المختلفة، وسعر الصرف المحدد يخضع لسعر الصرف في الوقت الفعلي في وقت إعادة الشحن.',
  'rechargeAgreement.section2.subtitle3': '2.3 حدود إعادة الشحن',
  'rechargeAgreement.section2.limit1': 'الحد الأدنى لإعادة الشحن الواحدة: 1 يوان (أو ما يعادله بالعملات الأخرى)',
  'rechargeAgreement.section2.limit2': 'الحد الأقصى لإعادة الشحن الواحدة: 50,000 يوان (أو ما يعادله بالعملات الأخرى)',
  'rechargeAgreement.section2.limit3': 'الحد التراكمي اليومي لإعادة الشحن: 100,000 يوان (أو ما يعادله بالعملات الأخرى)',
  'rechargeAgreement.section2.note': 'ملاحظة: قد تختلف حدود إعادة الشحن اعتماداً على طريقة الدفع ومستوى الحساب وعوامل أخرى. يرجى الرجوع إلى صفحة إعادة الشحن للحصول على التفاصيل.',
  'rechargeAgreement.section3.title': 'ثالثاً: وصول إعادة الشحن',
  'rechargeAgreement.section3.subtitle1': '3.1 وقت الوصول',
  'rechargeAgreement.section3.time1': 'Alipay, WeChat Pay: وصول فوري',
  'rechargeAgreement.section3.time2': 'البطاقة المصرفية: 1-3 أيام عمل',
  'rechargeAgreement.section3.time3': 'USDT: وفقاً لوقت تأكيد البلوك تشين، عادة 10-30 دقيقة',
  'rechargeAgreement.section3.subtitle2': '3.2 معالجة الاستثناءات',
  'rechargeAgreement.section3.content1': 'إذا لم تصل إعادة الشحن في الوقت المناسب، يرجى الاحتفاظ بإثبات الدفع والاتصال بخدمة العملاء على الفور. ستعالج المنصة مشكلة إعادة الشحن الخاصة بك في أقرب وقت ممكن بعد التحقق.',
  'rechargeAgreement.section4.title': 'رابعاً: سياسة الاسترداد',
  'rechargeAgreement.section4.important': 'مهم: بعد نجاح إعادة الشحن، لا يدعم رصيد الحساب الاسترداد المباشر. يمكن استخدام الرصيد فقط لاستهلاك الخدمات داخل المنصة.',
  'rechargeAgreement.section4.subtitle1': '4.1 شروط الاسترداد',
  'rechargeAgreement.section4.content1': 'يمكنك طلب الاسترداد في الحالات التالية:',
  'rechargeAgreement.section4.refund1': 'إعادة شحن مكررة بسبب عطل في نظام المنصة',
  'rechargeAgreement.section4.refund2': 'الخدمة غير متاحة بسبب أسباب المنصة، ولم يتم استهلاك رصيد الحساب',
  'rechargeAgreement.section4.refund3': 'ظروف خاصة أخرى وافقت عليها المنصة بعد المراجعة',
  'rechargeAgreement.section4.subtitle2': '4.2 عملية الاسترداد',
  'rechargeAgreement.section4.process1': 'تقديم طلب الاسترداد وشرح السبب',
  'rechargeAgreement.section4.process2': 'مراجعة المنصة (عادة 3-7 أيام عمل)',
  'rechargeAgreement.section4.process3': 'بعد الموافقة، سيتم إرجاع الاسترداد إلى حساب الدفع الخاص بك',
  'rechargeAgreement.section5.title': 'خامساً: أمان الحساب',
  'rechargeAgreement.section5.content1': 'أنت مسؤول عن الحفاظ بشكل صحيح على معلومات الحساب وكلمة المرور. لا تتحمل المنصة المسؤولية عن الخسائر الناجمة عن سرقة الحساب أو تسريب كلمة المرور بسبب أسبابك الخاصة.',
  'rechargeAgreement.section5.content2': 'إذا اكتشفت أي شذوذ في الحساب، يرجى الاتصال بخدمة العملاء على الفور وتغيير كلمة المرور. ستعينك المنصة في معالجة المشاكل ذات الصلة.',
  'rechargeAgreement.section6.title': 'سادساً: إخلاء المسؤولية',
  'rechargeAgreement.section6.disclaimer1': 'لا تتحمل المنصة المسؤولية عن انقطاع الخدمة الناجم عن القوة القاهرة (مثل الكوارث الطبيعية والحرب والإجراءات الحكومية وما إلى ذلك)',
  'rechargeAgreement.section6.disclaimer2': 'لمشاكل إعادة الشحن الناجمة عن أعطال منصات الدفع التابعة لجهات خارجية، ستعين المنصة في المعالجة ولكنها لا تتحمل المسؤولية المباشرة',
  'rechargeAgreement.section6.disclaimer3': 'الخسائر الناجمة عن انتهاكات المستخدم لهذه الاتفاقية أو القوانين واللوائح ذات الصلة يتحملها المستخدم نفسه',
  'rechargeAgreement.section7.title': 'سابعاً: تعديل الاتفاقية',
  'rechargeAgreement.section7.content1': 'للمنصة الحق في تعديل هذه الاتفاقية وفقاً لاحتياجات تطوير الأعمال. بعد تعديل الاتفاقية، سيتم الإعلان عنها في مكان بارز على المنصة. إذا واصلت استخدام خدمة إعادة الشحن، يُعتبر ذلك قبولاً للاتفاقية المعدلة.',
  'rechargeAgreement.section8.title': 'ثامناً: معلومات الاتصال',
  'rechargeAgreement.section8.content1': 'إذا كان لديك أي أسئلة حول هذه الاتفاقية، أو تحتاج إلى طلب الاسترداد أو معالجة مشاكل إعادة الشحن، يرجى الاتصال بنا من خلال الطرق التالية:',
  'rechargeAgreement.section8.contact1': 'بريد خدمة العملاء: support@example.com',
  'rechargeAgreement.section8.contact2': 'خدمة العملاء عبر الإنترنت: أيام العمل 9:00-18:00',
  'rechargeAgreement.section8.contact3': 'مركز المساعدة: عرض الأسئلة الشائعة',
  // تدويل الملف الشخصي
  'profile.editProfile': 'تعديل الملف الشخصي',
  'profile.creditScore': 'الدرجة الائتمانية',
  'profile.level': 'المستوى',
  'profile.balance': 'الرصيد',
  'profile.tab.basic': 'المعلومات الأساسية',
  'profile.tab.account': 'أصول الحساب',
  'profile.section.personal': 'المعلومات الشخصية',
  'profile.section.contact': 'الاتصال',
  'profile.section.wallet': 'محفظة USDT',
  'profile.label.username': 'اسم المستخدم',
  'profile.label.realName': 'الاسم الحقيقي',
  'profile.label.accountStatus': 'حالة الحساب',
  'profile.label.phone': 'رقم الهاتف',
  'profile.label.email': 'البريد الإلكتروني',
  'profile.label.registerTime': 'وقت التسجيل',
  'profile.label.availableBalance': 'الرصيد المتاح',
  'profile.label.frozenAmount': 'المبلغ المجمد',
  'profile.value.notVerified': 'غير موثق',
  'profile.value.notBound': 'غير مرتبط',
  'profile.value.noAddress': 'لا يوجد عنوان TRC20',
  'profile.value.noDescription': 'هذا الشخص كسول ولم يكتب شيئًا',
  'profile.status.normal': 'عادي',
  'profile.status.disabled': 'معطل',
  'profile.tooltip.verified': 'موثق',
  'profile.tooltip.unverified': 'التوثيق الآن',
  'profile.banner.construction': 'هذه الصفحة قيد الإنشاء...',
  'profile.modal.title': 'تعديل الملف الشخصي',
  'profile.modal.cancel': 'إلغاء',
  'profile.modal.save': 'حفظ التغييرات',
  'profile.modal.avatarSection': 'إعدادات الصورة الرمزية',
  'profile.modal.basicSection': 'المعلومات الأساسية',
  'profile.modal.contactSection': 'معلومات الاتصال',
  'profile.modal.changeAvatar': 'تغيير الصورة الرمزية',
  'profile.modal.avatarHint': 'يدعم تنسيقات JPG و PNG، بحد أقصى 2 ميجابايت',
  'profile.modal.nickname': 'اللقب',
  'profile.modal.nicknamePlaceholder': 'أدخل لقبك',
  'profile.modal.description': 'السيرة الذاتية',
  'profile.modal.descriptionPlaceholder': 'قدم نفسك في جملة واحدة...',
  'profile.modal.phone': 'الهاتف',
  'profile.modal.email': 'البريد الإلكتروني',
  'profile.message.avatarSizeLimit': 'لا يمكن أن يتجاوز حجم الصورة 2 ميجابايت',
  'profile.message.avatarUploadSuccess': 'تم تحميل الصورة الرمزية بنجاح',
  'profile.message.saveSuccess': 'تم الحفظ بنجاح',
  'profile.message.saveFailed': 'فشل الحفظ',
  'profile.message.uploadAvatarFailed': 'فشل تحميل الصورة الرمزية',
  'profile.message.operationFailed': 'فشلت العملية',
  'privacyPreferences.title': 'تفضيلات الخصوصية',
  'privacyPreferences.description': 'إدارة إعدادات الخصوصية الخاصة بك والتحكم في كيفية جمعنا واستخدامنا لبياناتك',
  'privacyPreferences.back': 'رجوع',
  'privacyPreferences.save': 'حفظ الإعدادات',
  'privacyPreferences.saveSuccess': 'تم حفظ تفضيلات الخصوصية بنجاح',
  'privacyPreferences.saveError': 'فشل الحفظ، يرجى المحاولة لاحقاً',
  'privacyPreferences.required': 'مطلوب',
  'privacyPreferences.info': 'سيتم حفظ تفضيلات الخصوصية الخاصة بك محلياً وسيتم تطبيقها تلقائياً في زيارتك القادمة. قم بتسجيل الدخول لمزامنة الإعدادات مع السحابة.',
  'privacyPreferences.info.loggedIn': 'سيتم حفظ تفضيلات الخصوصية الخاصة بك في حسابك ومزامنتها عبر جميع أجهزتك. يمكنك العودة إلى هذه الصفحة لتعديل هذه الإعدادات في أي وقت.',
  'cookieBanner.message': 'نستخدم ملفات تعريف الارتباط والتخزين المحلي لتسجيل الدخول والسمة والوظائف الأساسية. بالمتابعة فإنك توافق على سياسة الخصوصية.',
  'cookieBanner.acceptAll': 'قبول الكل',
  'cookieBanner.essentialOnly': 'الأساسية فقط',
  'cookieBanner.settings': 'التفضيلات',
  'privacyPreferences.cookies.title': 'تفضيلات ملفات تعريف الارتباط',
  'privacyPreferences.cookies.description': 'تساعدنا ملفات تعريف الارتباط على توفير تجربة خدمة أفضل. يمكنك اختيار قبول أو رفض أنواع معينة من ملفات تعريف الارتباط.',
  'privacyPreferences.cookies.essential': 'ملفات تعريف الارتباط الأساسية',
  'privacyPreferences.cookies.essential.desc': 'هذه الملفات ضرورية لعمل الموقع بشكل صحيح ولا يمكن تعطيلها. تُستخدم عادة للأمان وتسجيل الدخول والوظائف الأساسية.',
  'privacyPreferences.cookies.functional': 'ملفات تعريف الارتباط الوظيفية',
  'privacyPreferences.cookies.functional.desc': 'تسمح هذه الملفات للموقع بتذكر اختياراتك وتوفير وظائف محسّنة وتجربة مخصصة.',
  'privacyPreferences.cookies.analytics': 'ملفات تعريف الارتباط التحليلية',
  'privacyPreferences.cookies.analytics.desc': 'تساعدنا هذه الملفات على فهم كيفية استخدام الزوار للموقع حتى نتمكن من تحسين خدماتنا.',
  'privacyPreferences.cookies.marketing': 'ملفات تعريف الارتباط التسويقية',
  'privacyPreferences.cookies.marketing.desc': 'تُستخدم هذه الملفات لتتبع نشاط التصفح الخاص بك لعرض الإعلانات والمحتوى ذي الصلة.',
  'privacyPreferences.data.title': 'تفضيلات جمع البيانات',
  'privacyPreferences.data.description': 'التحكم في كيفية جمعنا واستخدامنا لبياناتك لتحسين تجربة الخدمة.',
  'privacyPreferences.data.collection': 'جمع البيانات',
  'privacyPreferences.data.collection.desc': 'اسمح لنا بجمع بيانات الاستخدام اللازمة لتوفير وتحسين الخدمات.',
  'privacyPreferences.data.analytics': 'تحليل البيانات',
  'privacyPreferences.data.analytics.desc': 'اسمح لنا بتحليل أنماط استخدامك لتحسين أداء الخدمة وتجربة المستخدم.',
  'privacyPreferences.data.personalization': 'التخصيص',
  'privacyPreferences.data.personalization.desc': 'اسمح لنا بتوفير محتوى وتوصيات مخصصة بناءً على تفضيلاتك وعادات الاستخدام.',
  'privacyPreferences.marketing.title': 'تفضيلات التسويق',
  'privacyPreferences.marketing.description': 'اختر أنواع الاتصالات التسويقية التي ترغب في تلقيها.',
  'privacyPreferences.marketing.emails': 'رسائل البريد الإلكتروني التسويقية',
  'privacyPreferences.marketing.emails.desc': 'تلقي إشعارات البريد الإلكتروني حول تحديثات المنتجات والعروض الترويجية والعروض الخاصة.',
  'privacyPreferences.marketing.sms': 'رسائل SMS التسويقية',
  'privacyPreferences.marketing.sms.desc': 'تلقي إشعارات SMS حول التحديثات المهمة والعروض الترويجية.',
  'privacyPreferences.marketing.push': 'الإشعارات الفورية',
  'privacyPreferences.marketing.push.desc': 'تلقي إشعارات المتصفح الفورية، بما في ذلك تحديثات المنتجات والرسائل المهمة.',
  'privacyPreferences.thirdParty.title': 'مشاركة البيانات مع أطراف ثالثة',
  'privacyPreferences.thirdParty.description': 'التحكم في السماح بمشاركة بياناتك مع مزودي الخدمات من الأطراف الثالثة.',
  'privacyPreferences.thirdParty.sharing': 'مشاركة البيانات مع أطراف ثالثة',
  'privacyPreferences.thirdParty.sharing.desc': 'اسمح لنا بمشاركة بيانات الاستخدام المجهولة مع مزودي الخدمات الموثوقين من الأطراف الثالثة لتحسين الخدمات.',
  
  // سياسة الخصوصية
  'privacyPolicy.title': 'سياسة الخصوصية',
  'privacyPolicy.lastUpdated': 'آخر تحديث: {date}',
  'privacyPolicy.intro1': 'تصف سياسة الخصوصية هذه كيف تجمع منصة AIMATEX (المشار إليها فيما يلي بـ "نحن" أو "هذه المنصة") معلوماتك الشخصية وتستخدمها وتخزنها وتحميها عند استخدامك لخدماتنا، وكذلك حقوقك في الخصوصية. نحن نولي أهمية كبيرة لحماية خصوصيتك. يرجى قراءة سياسة الخصوصية هذه بعناية.',
  'privacyPolicy.intro2': 'استخدامك لخدماتنا يعني موافقتك على سياسة الخصوصية هذه. إذا كنت لا توافق على أي جزء من سياسة الخصوصية هذه، يرجى عدم استخدام خدماتنا.',
  'privacyPolicy.section1.title': 'I. المعلومات التي نجمعها',
  'privacyPolicy.section1.1.title': '1.1 المعلومات التي تقدمها',
  'privacyPolicy.section1.1.intro': 'عند استخدام هذه الخدمة، قد تحتاج إلى تقديم المعلومات التالية:',
  'privacyPolicy.section1.1.item1.label': 'معلومات الحساب',
  'privacyPolicy.section1.1.item1.desc': 'اسم المستخدم، عنوان البريد الإلكتروني، كلمة المرور، رقم الهاتف، إلخ.',
  'privacyPolicy.section1.1.item2.label': 'معلومات الملف الشخصي',
  'privacyPolicy.section1.1.item2.desc': 'الصورة الرمزية، الاسم المستعار، السيرة الذاتية، إلخ. (اختياري)',
  'privacyPolicy.section1.1.item3.label': 'معلومات الدفع',
  'privacyPolicy.section1.1.item3.desc': 'طرق الدفع، عنوان الفوترة، إلخ. (لمعالجة المدفوعات)',
  'privacyPolicy.section1.1.item4.label': 'المحتوى المُنشأ',
  'privacyPolicy.section1.1.item4.desc': 'مطالبات النص، صور المرجع، مقاطع الفيديو والموسيقى والصور ونماذج 3D المُنشأة، إلخ. التي تقوم بتحميلها',
  'privacyPolicy.section1.2.title': '1.2 المعلومات المجمعة تلقائياً',
  'privacyPolicy.section1.2.intro': 'عند استخدام هذه الخدمة، قد نجمع تلقائياً المعلومات التالية:',
  'privacyPolicy.section1.2.item1.label': 'معلومات الجهاز',
  'privacyPolicy.section1.2.item1.desc': 'نوع الجهاز، نظام التشغيل، نوع المتصفح والإصدار، معرفات الجهاز، إلخ.',
  'privacyPolicy.section1.2.item2.label': 'بيانات الاستخدام',
  'privacyPolicy.section1.2.item2.desc': 'وقت الوصول، الصفحات التي تمت زيارتها، الميزات المستخدمة، سجلات العمليات، إلخ.',
  'privacyPolicy.section1.2.item3.label': 'معلومات الشبكة',
  'privacyPolicy.section1.2.item3.desc': 'عنوان IP، نوع الشبكة، مشغل الشبكة، إلخ.',
  'privacyPolicy.section1.2.item4.label': 'معلومات السجل',
  'privacyPolicy.section1.2.item4.desc': 'سجلات الأخطاء، بيانات الأداء، إلخ.',
  'privacyPolicy.section1.3.title': '1.3 ملفات تعريف الارتباط والتقنيات المشابهة',
  'privacyPolicy.section1.3.intro': 'نستخدم ملفات تعريف الارتباط والتقنيات المشابهة لـ:',
  'privacyPolicy.section1.3.item1': 'الحفاظ على حالة تسجيل الدخول الخاصة بك',
  'privacyPolicy.section1.3.item2': 'تذكر تفضيلاتك (مثل اللغة، المظهر، إلخ.)',
  'privacyPolicy.section1.3.item3': 'تحليل استخدام الخدمة لتحسين جودة الخدمة',
  'privacyPolicy.section1.3.item4': 'توفير تجربة مخصصة',
  'privacyPolicy.section1.3.note': 'يمكنك رفض ملفات تعريف الارتباط من خلال إعدادات المتصفح، ولكن قد يؤثر ذلك على استخدام بعض الميزات.',
  'privacyPolicy.section2.title': 'II. الغرض من استخدام المعلومات',
  'privacyPolicy.section2.intro': 'نجمع المعلومات ونستخدمها للأغراض التالية:',
  'privacyPolicy.section2.item1.label': 'تقديم الخدمات',
  'privacyPolicy.section2.item1.desc': 'معالجة طلبات إنشاء المحتوى الخاصة بك (مقاطع الفيديو والموسيقى والصور ونماذج 3D، إلخ)، إدارة حسابك وأعمالك، إلخ.',
  'privacyPolicy.section2.item2.label': 'تحسين الخدمات',
  'privacyPolicy.section2.item2.desc': 'تحليل الاستخدام، تحسين أداء الخدمة وتجربة المستخدم',
  'privacyPolicy.section2.item3.label': 'إدارة الحساب',
  'privacyPolicy.section2.item3.desc': 'التحقق من الهوية، معالجة المدفوعات، إرسال الإشعارات، إلخ.',
  'privacyPolicy.section2.item4.label': 'الأمان',
  'privacyPolicy.section2.item4.desc': 'اكتشاف ومنع الاحتيال، إساءة الاستخدام، التهديدات الأمنية، إلخ.',
  'privacyPolicy.section2.item5.label': 'دعم العملاء',
  'privacyPolicy.section2.item5.desc': 'الرد على استفساراتك، معالجة الشكاوى والملاحظات، إلخ.',
  'privacyPolicy.section2.item6.label': 'الامتثال القانوني',
  'privacyPolicy.section2.item6.desc': 'الامتثال للمتطلبات القانونية، التعاون مع تحقيقات إنفاذ القانون، إلخ.',
  'privacyPolicy.section3.title': 'III. مشاركة المعلومات والإفصاح عنها',
  'privacyPolicy.section3.1.title': '3.1 نحن لا نبيع معلوماتك الشخصية',
  'privacyPolicy.section3.1.content': 'نحن لا نبيع أو نؤجر أو نتاجر بمعلوماتك الشخصية لأطراف ثالثة.',
  'privacyPolicy.section3.2.title': '3.2 مقدمي الخدمات',
  'privacyPolicy.section3.2.intro': 'قد نشارك المعلومات مع الأنواع التالية من مقدمي الخدمات:',
  'privacyPolicy.section3.2.item1.label': 'مقدمو خدمات الحوسبة السحابية',
  'privacyPolicy.section3.2.item1.desc': 'لتخزين ومعالجة البيانات',
  'privacyPolicy.section3.2.item2.label': 'مقدمو خدمات الدفع',
  'privacyPolicy.section3.2.item2.desc': 'لمعالجة معاملات الدفع',
  'privacyPolicy.section3.2.item3.label': 'مقدمو خدمات التحليل',
  'privacyPolicy.section3.2.item3.desc': 'لتحليل استخدام الخدمة',
  'privacyPolicy.section3.2.item4.label': 'مقدمو خدمات دعم العملاء',
  'privacyPolicy.section3.2.item4.desc': 'لتقديم دعم العملاء',
  'privacyPolicy.section3.2.note': 'يمكن لمقدمي الخدمات هؤلاء استخدام المعلومات فقط لتقديم الخدمات لنا وليس لأغراض أخرى.',
  'privacyPolicy.section3.3.title': '3.3 المتطلبات القانونية',
  'privacyPolicy.section3.3.intro': 'قد نكشف عن معلوماتك في الحالات التالية:',
  'privacyPolicy.section3.3.item1': 'الامتثال للقوانين واللوائح وأوامر المحكمة أو المتطلبات الحكومية',
  'privacyPolicy.section3.3.item2': 'حماية حقوقنا أو ممتلكاتنا أو سلامتنا',
  'privacyPolicy.section3.3.item3': 'منع أو التحقيق في الأنشطة غير القانونية المحتملة',
  'privacyPolicy.section3.3.item4': 'حماية سلامة المستخدمين أو الجمهور',
  'privacyPolicy.section3.4.title': '3.4 نقل الأعمال',
  'privacyPolicy.section3.4.content': 'في حالة حدوث اندماج أو استحواذ أو نقل أصول، قد يتم نقل معلوماتك. سنخطرك قبل النقل.',
  'privacyPolicy.section4.title': 'IV. تخزين المعلومات وأمانها',
  'privacyPolicy.section4.1.title': '4.1 موقع التخزين',
  'privacyPolicy.section4.1.content': 'قد يتم تخزين معلوماتك على خوادم موجودة داخل أو خارج جمهورية الصين الشعبية. سنتخذ التدابير المناسبة لضمان أمان المعلومات.',
  'privacyPolicy.section4.2.title': '4.2 فترة التخزين',
  'privacyPolicy.section4.2.intro': 'نحتفظ بمعلوماتك فقط للفترة اللازمة:',
  'privacyPolicy.section4.2.item1': 'معلومات الحساب: خلال مدة حسابك وفترة بعد الإلغاء',
  'privacyPolicy.section4.2.item2': 'المحتوى المُنشأ: محفوظ وفقاً لإعداداتك أو المتطلبات القانونية',
  'privacyPolicy.section4.2.item3': 'بيانات الاستخدام: عادةً ما يتم الاحتفاظ بها لفترة أقصر للتحليل وتحسين الخدمة',
  'privacyPolicy.section4.3.title': '4.3 تدابير الأمان',
  'privacyPolicy.section4.3.intro': 'نتخذ تدابير الأمان التالية لحماية معلوماتك:',
  'privacyPolicy.section4.3.item1': 'النقل والتخزين المشفر',
  'privacyPolicy.section4.3.item2': 'التحكم في الوصول والمصادقة',
  'privacyPolicy.section4.3.item3': 'عمليات تدقيق الأمان المنتظمة وفحص الثغرات',
  'privacyPolicy.section4.3.item4': 'تدريب الموظفين واتفاقيات السرية',
  'privacyPolicy.section4.3.note': 'يرجى ملاحظة أنه لا توجد تدابير أمان آمنة بنسبة 100%. لا يمكننا ضمان الأمان المطلق للمعلومات.',
  'privacyPolicy.section5.title': 'V. حقوقك',
  'privacyPolicy.section5.intro': 'وفقاً للقوانين واللوائح المعمول بها، لديك الحقوق التالية:',
  'privacyPolicy.section5.item1.label': 'حق الوصول',
  'privacyPolicy.section5.item1.desc': 'عرض معلوماتك الشخصية التي نمتلكها',
  'privacyPolicy.section5.item2.label': 'حق التصحيح',
  'privacyPolicy.section5.item2.desc': 'تصحيح المعلومات غير الدقيقة أو غير الكاملة',
  'privacyPolicy.section5.item3.label': 'حق الحذف',
  'privacyPolicy.section5.item3.desc': 'طلب حذف معلوماتك الشخصية (ما لم يتطلب القانون الاحتفاظ بها)',
  'privacyPolicy.section5.item4.label': 'حق سحب الموافقة',
  'privacyPolicy.section5.item4.desc': 'سحب موافقتك على معالجة المعلومات',
  'privacyPolicy.section5.item5.label': 'حق قابلية نقل البيانات',
  'privacyPolicy.section5.item5.desc': 'الحصول على نسخة من معلوماتك الشخصية',
  'privacyPolicy.section5.item6.label': 'حق الاعتراض',
  'privacyPolicy.section5.item6.desc': 'الاعتراض على أنشطة معالجة المعلومات معينة',
  'privacyPolicy.section5.note': 'لممارسة الحقوق المذكورة أعلاه، يرجى الاتصال بنا من خلال معلومات الاتصال في نهاية سياسة الخصوصية هذه.',
  'privacyPolicy.section6.title': 'VI. حماية القاصرين',
  'privacyPolicy.section6.content1': 'هذه الخدمة موجهة بشكل أساسي للمستخدمين الذين تزيد أعمارهم عن 18 عاماً. إذا كان عمرك أقل من 18 عاماً، يرجى استخدام هذه الخدمة بموافقة وتحت إشراف وصيك.',
  'privacyPolicy.section6.content2': 'إذا اكتشفنا أننا جمعنا معلومات شخصية لمستخدمين تقل أعمارهم عن 18 عاماً دون موافقة الوصي، فسنحذف المعلومات ذات الصلة في أقرب وقت ممكن.',
  'privacyPolicy.section7.title': 'VII. روابط الأطراف الثالثة',
  'privacyPolicy.section7.content': 'قد تحتوي هذه الخدمة على روابط لمواقع ويب تابعة لأطراف ثالثة. نحن لسنا مسؤولين عن ممارسات الخصوصية لهذه المواقع التابعة لأطراف ثالثة. عند زيارة هذه المواقع، يرجى مراجعة سياسات الخصوصية الخاصة بها.',
  'privacyPolicy.section8.title': 'VIII. تغييرات سياسة الخصوصية',
  'privacyPolicy.section8.content1': 'قد نحدث سياسة الخصوصية هذه من وقت لآخر. سيتم إخطارك بالتغييرات المهمة قبل 30 يوماً على الأقل من دخولها حيز التنفيذ. الاستمرار في استخدام الخدمة يعني موافقتك على سياسة الخصوصية المحدثة.',
  'privacyPolicy.section8.content2': 'سنقوم بتحديث تاريخ "آخر تحديث" في أعلى هذه الصفحة وإخطارك بالتغييرات المهمة عبر البريد الإلكتروني أو الإشعارات داخل التطبيق.',
  'privacyPolicy.section9.title': 'IX. اتصل بنا',
  'privacyPolicy.section9.intro': 'إذا كان لديك أي أسئلة أو تعليقات أو شكاوى حول سياسة الخصوصية هذه، يرجى الاتصال بنا من خلال الطرق التالية:',
  'privacyPolicy.section9.email': 'البريد الإلكتروني: {email}',
  'privacyPolicy.section9.hours': 'ساعات خدمة العملاء: أيام العمل 9:00-18:00',
  'privacyPolicy.section9.response': 'سنرد على طلبك في غضون وقت معقول.',
  
  // شروط الخدمة
  'termsOfService.title': 'شروط الخدمة',
  'termsOfService.lastUpdated': 'آخر تحديث: {date}',
  'termsOfService.intro': 'قبل استخدام خدماتنا، يرجى قراءة شروط الخدمة هذه بعناية. من خلال الوصول إلى منصة AIMATEX أو استخدامها (المشار إليها فيما يلي بـ "هذه المنصة" أو "الخدمة")، فإنك توافق على الالتزام بشروط الخدمة هذه. إذا كنت لا توافق على أي جزء من شروط الخدمة هذه، يرجى عدم استخدام خدماتنا.',
  'termsOfService.section1.title': 'I. التعريفات والتفسير',
  'termsOfService.section1.1.title': '1.1 التعريفات',
  'termsOfService.section1.1.intro': 'في شروط الخدمة هذه، ما لم يشير السياق إلى خلاف ذلك، فإن المصطلحات التالية لها المعاني التالية:',
  'termsOfService.section1.1.item1.label': '"المنصة" أو "هذه المنصة"',
  'termsOfService.section1.1.item1.desc': 'يشير إلى منصة خدمة إنشاء الفيديو AIMATEX، بما في ذلك على سبيل المثال لا الحصر المواقع الإلكترونية والتطبيقات المحمولة والخدمات ذات الصلة.',
  'termsOfService.section1.1.item2.label': '"نحن"، "لدينا"، "الشركة"',
  'termsOfService.section1.1.item2.desc': 'يشير إلى مشغل منصة AIMATEX، أي ProTX Team.',
  'termsOfService.section1.1.item3.label': '"أنت"، "المستخدم"',
  'termsOfService.section1.1.item3.desc': 'يشير إلى أي فرد أو شركة أو كيان قانوني آخر يصل إلى هذه الخدمة أو يستخدمها.',
  'termsOfService.section1.1.item4.label': '"الخدمة"',
  'termsOfService.section1.1.item4.desc': 'يشير إلى جميع الوظائف والخدمات المقدمة من هذه المنصة، بما في ذلك على سبيل المثال لا الحصر إنشاء الفيديو والموسيقى والصور ونماذج 3D بالذكاء الاصطناعي والمحتويات الأخرى، اختيار النماذج، إدارة الأعمال، إدارة حسابات المستخدمين، إلخ.',
  'termsOfService.section1.1.item5.label': '"المحتوى"',
  'termsOfService.section1.1.item5.desc': 'يشير إلى أي نص أو صور أو مقاطع فيديو أو صوت ومواد أخرى يتم تحميلها أو إنشاؤها أو إنشاؤها أو مشاركتها من قبل المستخدمين من خلال هذه المنصة.',
  'termsOfService.section1.1.item6.label': '"المحتوى المُنشأ"',
  'termsOfService.section1.1.item6.desc': 'يشير إلى مقاطع الفيديو والموسيقى والصور ونماذج 3D والأعمال الأخرى التي ينشئها المستخدمون باستخدام نماذج الذكاء الاصطناعي لهذه المنصة.',
  'termsOfService.section1.1.item7.label': '"الحساب"',
  'termsOfService.section1.1.item7.desc': 'يشير إلى حساب المستخدم المسجل من قبل المستخدمين على هذه المنصة.',
  'termsOfService.section2.title': 'II. وصف الخدمة',
  'termsOfService.section2.1.title': '2.1 محتوى الخدمة',
  'termsOfService.section2.1.intro': 'توفر هذه المنصة خدمات شاملة لإنشاء المحتوى بالذكاء الاصطناعي، بما في ذلك على سبيل المثال لا الحصر:',
  'termsOfService.section2.1.item1': 'إنشاء النص إلى الوسائط (فيديو، موسيقى، صور، نماذج 3D، إلخ) (Text-to-Media)',
  'termsOfService.section2.1.item2': 'إنشاء الصورة إلى الوسائط (فيديو، نماذج 3D، إلخ) (Image-to-Media)',
  'termsOfService.section2.1.item3': 'إدارة وعرض الأعمال المُنشأة المختلفة',
  'termsOfService.section2.1.item4': 'اختيار وإدارة النماذج',
  'termsOfService.section2.1.item5': 'حسابات المستخدمين والمركز الشخصي',
  'termsOfService.section2.1.item6': 'خدمات الاشتراك والدفع',
  'termsOfService.section2.2.title': '2.2 تغييرات الخدمة',
  'termsOfService.section2.2.content': 'نحتفظ بالحق في تعديل أو تعليق أو إنهاء جزء أو كل الخدمة في أي وقت دون إشعار مسبق. نحن لسنا مسؤولين عن أي خسائر ناجمة عن تغييرات الخدمة.',
  'termsOfService.section3.title': 'III. حسابات المستخدمين',
  'termsOfService.section3.1.title': '3.1 تسجيل الحساب',
  'termsOfService.section3.1.intro': 'يتطلب استخدام هذه الخدمة تسجيل حساب. عند التسجيل، فإنك توافق على:',
  'termsOfService.section3.1.item1': 'تقديم معلومات تسجيل صحيحة ودقيقة وكاملة',
  'termsOfService.section3.1.item2': 'تحديث معلومات التسجيل في الوقت المناسب للحفاظ على صحتها ودقتها واكتمالها',
  'termsOfService.section3.1.item3': 'أن تكون مسؤولاً عن جميع الأنشطة تحت حسابك',
  'termsOfService.section3.1.item4': 'الحفاظ على أمان كلمة مرور حسابك وعدم نقل أو بيع أو إقراض حسابك للآخرين',
  'termsOfService.section3.2.title': '3.2 قيود العمر',
  'termsOfService.section3.2.content': 'يجب أن يكون عمرك 18 عاماً على الأقل لاستخدام هذه الخدمة. إذا كان عمرك أقل من 18 عاماً، يرجى استخدام هذه الخدمة بموافقة وتحت إشراف وصيك.',
  'termsOfService.section3.3.title': '3.3 أمان الحساب',
  'termsOfService.section3.3.content': 'أنت مسؤول عن الحفاظ على أمان حسابك. إذا اكتشفت أن حسابك قد تم اختراقه أو يوجد ثغرة أمنية، يرجى إبلاغنا على الفور. نحن لسنا مسؤولين عن الخسائر الناجمة عن فشلك في حماية معلومات حسابك بشكل صحيح.',
  'termsOfService.section4.title': 'IV. قواعد الاستخدام',
  'termsOfService.section4.1.title': '4.1 الأنشطة المحظورة',
  'termsOfService.section4.1.intro': 'عند استخدام هذه الخدمة، لا يجب عليك:',
  'termsOfService.section4.1.item1': 'إنشاء أو تحميل أو مشاركة محتوى غير قانوني أو ضار أو مهدد أو مسيء أو مضايق أو قذف أو فاحش أو فاحش أو ينتهك خصوصية أو حقوق الملكية الفكرية للآخرين',
  'termsOfService.section4.1.item2': 'إنشاء أو نشر معلومات كاذبة أو محتوى مضلل أو ضار',
  'termsOfService.section4.1.item3': 'استخدام هذه الخدمة للاحتيال التجاري أو غسيل الأموال أو أنشطة غير قانونية أخرى',
  'termsOfService.section4.1.item4': 'التدخل في أو تدمير التشغيل العادي لهذه المنصة، بما في ذلك على سبيل المثال لا الحصر استخدام الأدوات الآلية، والعناكب، والفيروسات، إلخ.',
  'termsOfService.section4.1.item5': 'الوصول غير المصرح به إلى أي أنظمة أو بيانات أو حسابات لهذه المنصة',
  'termsOfService.section4.1.item6': 'نسخ أو تعديل أو توزيع أو بيع أو تأجير أي جزء من هذه المنصة',
  'termsOfService.section4.1.item7': 'الهندسة العكسية أو إلغاء التجميع أو تفكيك أي برنامج من هذه المنصة',
  'termsOfService.section4.2.title': '4.2 مسؤولية المحتوى',
  'termsOfService.section4.2.content': 'أنت مسؤول بالكامل عن جميع المحتويات التي يتم إنشاؤها أو تحميلها أو مشاركتها من خلال هذه المنصة. نحن لا نراجع مسبقاً المحتوى الذي ينشئه المستخدمون، لكننا نحتفظ بالحق في حذف المحتوى المخالف في أي وقت.',
  'termsOfService.section5.title': 'V. الملكية الفكرية',
  'termsOfService.section5.1.title': '5.1 الملكية الفكرية للمنصة',
  'termsOfService.section5.1.content': 'جميع حقوق الملكية الفكرية لهذه المنصة، بما في ذلك على سبيل المثال لا الحصر العلامات التجارية والبراءات وحقوق النشر والأسرار التجارية، إلخ، تنتمي إلينا أو إلى أصحاب الحقوق المعنيين. لا يمكنك استخدامها دون إذن.',
  'termsOfService.section5.2.title': '5.2 المحتوى الذي ينشئه المستخدم',
  'termsOfService.section5.2.content': 'حقوق الملكية الفكرية للمحتوى الذي تنشئه من خلال هذه المنصة تنتمي إليك. ومع ذلك، فإنك تمنحنا حقاً غير حصري وعالمي ومجاني وقابل للترخيص من الباطن لاستخدام وعرض وتوزيع محتواك لتقديم وتحسين الخدمات.',
  'termsOfService.section5.3.title': '5.3 نماذج الذكاء الاصطناعي',
  'termsOfService.section5.3.content': 'حقوق الملكية الفكرية لنماذج الذكاء الاصطناعي (بما في ذلك نماذج Sora) المستخدمة من قبل هذه المنصة تنتمي إلى مطوريها. لا يمكنك نسخ أو تعديل أو توزيع هذه النماذج.',
  'termsOfService.section6.title': 'VI. الخدمات المدفوعة',
  'termsOfService.section6.1.title': '6.1 نماذج الدفع',
  'termsOfService.section6.1.content': 'توفر هذه المنصة نموذجين للدفع: الاشتراك والدفع لكل استخدام. الأسعار المحددة وطرق الفوترة تخضع لإعلانات المنصة.',
  'termsOfService.section6.2.title': '6.2 الدفع',
  'termsOfService.section6.2.content': 'أنت توافق على دفع رسوم الخدمة وفقاً للأسعار المعلن عنها من قبل المنصة. يتم حساب جميع الرسوم باليوان الصيني أو العملات الأخرى المدعومة من قبل المنصة. بعد الدفع الناجح، الرسوم غير قابلة للاسترداد، ما لم ينص القانون على خلاف ذلك أو قدمنا التزامات أخرى.',
  'termsOfService.section6.3.title': '6.3 سياسة الاسترداد',
  'termsOfService.section6.3.content': 'ما لم ينص القانون على خلاف ذلك أو قدمنا التزامات أخرى، الرسوم المدفوعة غير قابلة للاسترداد. إذا لم يمكن استخدام الخدمة بشكل طبيعي بسبب مشاكل المنصة، فسنقدم استرداداً أو تعويضاً وفقاً للوضع الفعلي.',
  'termsOfService.section7.title': 'VII. توفر الخدمة',
  'termsOfService.section7.1.title': '7.1 انقطاع الخدمة',
  'termsOfService.section7.1.intro': 'نحن لسنا مسؤولين عن انقطاعات الخدمة الناجمة عن الأسباب التالية:',
  'termsOfService.section7.1.item1': 'صيانة النظام أو الترقية أو الأعطال',
  'termsOfService.section7.1.item2': 'عوامل القوة القاهرة (مثل الكوارث الطبيعية والحروب والإضرابات، إلخ.)',
  'termsOfService.section7.1.item3': 'مشاكل مع مقدمي خدمات الأطراف الثالثة',
  'termsOfService.section7.1.item4': 'أعطال الشبكة أو مشاكل أجهزة المستخدم',
  'termsOfService.section7.2.title': '7.2 ضمان الخدمة',
  'termsOfService.section7.2.content': 'نسعى جاهدين لضمان استقرار وتوفر الخدمة، لكننا لا نضمن أن الخدمة لن تنقطع أو خالية من الأخطاء أو آمنة تماماً. يتم توفير الخدمة "كما هي" و"كما متاحة" دون أي ضمانات صريحة أو ضمنية.',
  'termsOfService.section8.title': 'VIII. حماية الخصوصية',
  'termsOfService.section8.content': 'نحن نولي أهمية كبيرة لحماية خصوصيتك. للحصول على معلومات حول كيفية جمع معلوماتك الشخصية واستخدامها وحمايتها، يرجى الرجوع إلى سياسة الخصوصية الخاصة بنا. استخدام هذه الخدمة يعني موافقتك على سياسة الخصوصية الخاصة بنا.',
  'termsOfService.section9.title': 'IX. الحد من المسؤولية',
  'termsOfService.section9.1.title': '9.1 نطاق المسؤولية',
  'termsOfService.section9.1.intro': 'في أقصى حد يسمح به القانون، نحن لسنا مسؤولين عن أي أضرار مباشرة أو غير مباشرة أو عرضية أو خاصة أو تبعية ناتجة عن استخدام أو عدم القدرة على استخدام هذه الخدمة، بما في ذلك على سبيل المثال لا الحصر:',
  'termsOfService.section9.1.item1': 'فقدان الأرباح أو فقدان البيانات أو خسائر اقتصادية أخرى',
  'termsOfService.section9.1.item2': 'انقطاع الأعمال',
  'termsOfService.section9.1.item3': 'إصابة جسدية أو فقدان الممتلكات',
  'termsOfService.section9.1.item4': 'انتهاك الخصوصية',
  'termsOfService.section9.2.title': '9.2 حد المسؤولية',
  'termsOfService.section9.2.content': 'مسؤوليتنا الإجمالية لا تتجاوز المبلغ الإجمالي الذي دفعته فعلياً مقابل هذه الخدمة في الأشهر الـ 12 الماضية، أو 100 دولار (أيهما أعلى).',
  'termsOfService.section10.title': 'X. إنهاء الخدمة',
  'termsOfService.section10.1.title': '10.1 إنهاء من قبل المستخدم',
  'termsOfService.section10.1.content': 'يمكنك التوقف عن استخدام هذه الخدمة وإلغاء حسابك في أي وقت.',
  'termsOfService.section10.2.title': '10.2 إنهاء من قبل المنصة',
  'termsOfService.section10.2.intro': 'لدينا الحق في إنهاء أو تعليق حسابك وخدمتك فوراً في الحالات التالية:',
  'termsOfService.section10.2.item1': 'أنت تنتهك شروط الخدمة هذه',
  'termsOfService.section10.2.item2': 'أنت تشارك في أنشطة غير قانونية',
  'termsOfService.section10.2.item3': 'لم يتم استخدام حسابك لفترة طويلة',
  'termsOfService.section10.2.item4': 'المتطلبات القانونية أو التنظيمية',
  'termsOfService.section10.2.note': 'بعد إنهاء الخدمة، لن تتمكن من الوصول إلى حسابك والمحتوى المُنشأ، ما لم ينص القانون على خلاف ذلك.',
  'termsOfService.section11.title': 'XI. حل النزاعات',
  'termsOfService.section11.1.title': '11.1 التفاوض',
  'termsOfService.section11.1.content': 'إذا نشأ نزاع، يجب على كلا الطرفين محاولة حله أولاً من خلال التفاوض الودي.',
  'termsOfService.section11.2.title': '11.2 القانون المعمول به',
  'termsOfService.section11.2.content': 'تخضع شروط الخدمة هذه لقوانين جمهورية الصين الشعبية. إذا لم يتمكن كلا الطرفين من حل النزاع من خلال التفاوض، فسيتم تقديمه إلى محكمة شعبية ذات اختصاص في موقعنا.',
  'termsOfService.section12.title': 'XII. أحكام أخرى',
  'termsOfService.section12.1.title': '12.1 تعديل الشروط',
  'termsOfService.section12.1.content': 'نحتفظ بالحق في تعديل شروط الخدمة هذه في أي وقت. سيتم إخطارك بالتغييرات المهمة قبل 30 يوماً على الأقل من دخولها حيز التنفيذ. الاستمرار في استخدام الخدمة يعني موافقتك على الشروط المعدلة.',
  'termsOfService.section12.2.title': '12.2 القابلية للفصل',
  'termsOfService.section12.2.content': 'إذا تم اعتبار أي حكم من شروط الخدمة هذه باطلاً أو غير قابل للتنفيذ، فإنه لا يؤثر على صحة الأحكام الأخرى.',
  'termsOfService.section12.3.title': '12.3 الاتفاقية الكاملة',
  'termsOfService.section12.3.content': 'تشكل شروط الخدمة هذه الاتفاقية الكاملة بينك وبيننا فيما يتعلق باستخدام هذه الخدمة، وتحل محل جميع الاتفاقيات الشفهية أو المكتوبة السابقة.',
  'termsOfService.section13.title': 'XIII. اتصل بنا',
  'termsOfService.section13.intro': 'إذا كان لديك أي أسئلة حول شروط الخدمة هذه، يرجى الاتصال بنا من خلال الطرق التالية:',
  'termsOfService.section13.email': 'البريد الإلكتروني: {email}',
  'termsOfService.section13.hours': 'ساعات خدمة العملاء: أيام العمل 9:00-18:00',
  
  // Footer
  'footer.brand.description': 'يوفر خدمات الإنشاء بالذكاء الاصطناعي.',
  'footer.joinUs': 'انضم إلينا',
  'footer.product.title': 'المنتج',
  'footer.product.signup': 'إنشاء حساب',
  'footer.product.login': 'تسجيل الدخول',
  'footer.product.workspace': 'مساحة العمل',
  'footer.product.works': 'أعمالي',
  'footer.support.title': 'الدعم',
  'footer.support.help': 'مركز المساعدة',
  'footer.support.about': 'من نحن',
  'footer.support.feedback': 'التعليقات',
  'footer.support.contact': 'اتصل بنا',
  'footer.legal.title': 'قانوني',
  'footer.legal.privacy': 'سياسة الخصوصية',
  'footer.legal.terms': 'شروط الخدمة',
  'footer.legal.recharge': 'اتفاقية إعادة الشحن',
  'footer.resources.title': 'الموارد',
  'footer.resources.invite': 'دعوة الأصدقاء',
  'footer.resources.account': 'إدارة الحساب',
  'footer.resources.orders': 'مركز الطلبات',
  'footer.copyright': '© {year} {brand}. جميع الحقوق محفوظة.',
  'footer.description': 'توفر هذه المنصة خدمات الإنشاء بالذكاء الاصطناعي',
  'footer.openRobotX.title': 'Open Robot X',
  'footer.openRobotX.description': 'قاعدة بيانات عالمية للروبوتات البشرية مع مقارنة المواصفات ورؤى الصناعة',
  'footer.openRobotX.visit': 'زيارة Open Robot X',
  'footer.ai2obj.title': 'ai2obj',
  'footer.ai2obj.description': 'منصة توليد شاملة مدعومة بالذكاء الاصطناعي لإنشاء محتوى رقمي متنوع',
  'footer.aimatexMusic.title': 'AIMATEX-MUSIC',
  'footer.aimatexMusic.description': 'موسيقى سحابية شخصية: اكتشاف وقوائم تشغيل وتشغيل ومكتبة',
  
  // صفحة التسعير
  'pricing.title': 'اختر الخطة التي تناسبك',
  'pricing.plan.basic.sub': 'أساسي',
  'pricing.plan.pro.sub': 'احترافي',
  'pricing.plan.team.sub': 'فريق',
  'pricing.plan.popular': 'شائع',
  'pricing.plan.button.select': 'اختر هذه الخطة',
  'pricing.plan.button.subscribe': 'اشترك الآن',
  'pricing.plan.basic.videoQuota': '5/شهر',
  'pricing.plan.basic.videoDuration': '6-10ث',
  'pricing.plan.basic.videoQuality': '720P',
  'pricing.plan.pro.videoQuota': '30/شهر',
  'pricing.plan.pro.videoDuration': '10-15ث',
  'pricing.plan.pro.videoQuality': '1080P',
  'pricing.plan.team.videoQuota': '100/شهر',
  'pricing.plan.team.videoDuration': '10-15ث',
  'pricing.plan.team.videoQuality': '1080P/4K',
  'pricing.feature.videoQuota': 'حصة إنشاء الفيديو',
  'pricing.feature.videoDuration': 'مدة الفيديو',
  'pricing.feature.videoQuality': 'جودة الفيديو',
  'pricing.feature.storyboard': 'القصة المصورة',
  'pricing.feature.workflow': 'سير العمل',
  'pricing.feature.priorityQueue': 'قائمة انتظار ذات أولوية',
  'pricing.feature.exclusiveChannel': 'قناة حصرية',
  'pricing.feature.highestQuality': 'وضع أعلى جودة',
  'pricing.feature.sdImage': 'إنشاء صور SD',
  'pricing.feature.unlimited': 'غير محدود',
  'pricing.feature.promptOptimization': 'تحسين المطالبات',
  'pricing.feature.imageSize': 'حجم الصورة',
  'pricing.feature.storage': 'مساحة التخزين',
  'pricing.feature.commercialLicense': 'ترخيص تجاري',
  'pricing.feature.apiAccess': 'الوصول إلى API',
  'pricing.then': 'ثم',
  'cta.title': 'ابدأ في إنشاء مقاطع الفيديو الخاصة بك',
  'cta.description': 'سجل الآن وحول إبداعك إلى أعمال فيديو مذهلة باستخدام تقنية الذكاء الاصطناعي',
  'cta.button': 'ابدأ مجاناً',
  'technology.coreArchitecture': 'الهندسة المعمارية الأساسية',
  'technology.workflowEngine.title': 'محرك سير العمل المرئي',
  'technology.workflowEngine.description': 'دعم سير العمل المرئي قادم قريباً. كل عقدة هي تحكم دقيق في الإبداع.',
  'technology.node.checkpointLoader': 'Checkpoint Loader',
  'technology.node.clipTextPositive': 'CLIP Text (Positive)',
  'technology.node.clipTextNegative': 'CLIP Text (Negative)',
  'technology.node.ksamplerAdvanced': 'KSampler Advanced',
  'technology.node.vaeDecode': 'VAE Decode',
  'technology.node.previewImage': 'Preview Image',
  'technology.hud.systemResourceMonitor': 'مراقب موارد النظام',
  'technology.hud.gpuVram': 'GPU VRAM',
  'technology.terminal.console': 'console — zsh',
  'technology.button.runWorkflow': 'تشغيل سير العمل',
  'technology.button.running': 'جاري التشغيل...',
  'technology.log.systemInitialized': '> تم تهيئة النظام.',
  'technology.log.waitingForInput': '> في انتظار إدخال المستخدم...',
  'technology.log.loadingCheckpoint': 'Loading SDXL Checkpoint (fp16)...',
  'technology.log.tokenizingPrompt': 'Tokenizing positive prompt...',
  'technology.log.ksamplerSteps': 'KSampler: 30/30 steps (Euler A)',
  'technology.log.generationComplete': 'Generation complete.',
  'technology.benchmark.title': 'معيار الأداء النهائي',
  'technology.benchmark.description': 'من أجل هذا التحسين البالغ 0.5 ثانية، أعدنا كتابة 30% من المشغلين الأساسيين.',
  'technology.benchmark.fps.title': 'سرعة التوليد (FPS)',
  'technology.benchmark.fps.subtitle': 'Comparison @ 1080p',
  'technology.benchmark.vram.title': 'تحسين VRAM',
  'technology.benchmark.vram.subtitle': 'Lower is better',
  'technology.benchmark.productX': 'ProductX',
  'technology.benchmark.others': 'Others',
  'technology.benchmark.standard': 'Standard',
  'technology.galaxy.openEcology': 'النظام البيئي المفتوح',
  'technology.galaxy.title': 'كون النماذج اللامتناهي',
  'technology.galaxy.description': 'دعم اتصال Civitai المباشر، آلاف النماذج، تحميل بنقرة واحدة.',
  'technology.galaxy.autoSync': 'المزامنة التلقائية',
  
  // صفحة الملاحظات
  'feedback.leftPanel.title.line1': 'نستمع إلى',
  'feedback.leftPanel.title.line2': 'صوتك',
  'feedback.leftPanel.description': 'ملاحظاتك هي القوة الدافعة وراء تحسين منتجنا. سواء وجدت خطأ أو لديك فكرة رائعة لميزة جديدة، أخبرنا.',
  'feedback.contact.helpDoc.title': 'وثائق المساعدة',
  'feedback.contact.helpDoc.desc': 'تصفح الأسئلة الشائعة وأدلة المستخدم',
  'feedback.contact.email.title': 'دعم البريد الإلكتروني',
  'feedback.contact.service.title': 'الدعم عبر الإنترنت',
  'feedback.contact.service.hours': 'أيام العمل 9:00 - 18:00',
  'feedback.type.suggestion.title': 'اقتراح ميزة',
  'feedback.type.suggestion.desc': 'لدي أفكار جديدة أو اقتراحات للتحسين',
  'feedback.type.bug.title': 'تقرير خطأ',
  'feedback.type.bug.desc': 'واجهت خطأ أو استثناء',
  'feedback.type.question.title': 'استفسار الاستخدام',
  'feedback.type.question.desc': 'لا أفهم كيفية استخدام ميزة',
  'feedback.type.other.title': 'أخرى',
  'feedback.type.other.desc': 'أنواع أخرى من الملاحظات',
  'feedback.form.type.label': 'نوع الملاحظات',
  'feedback.form.title.label': 'ملخص موجز',
  'feedback.form.title.placeholder': 'اوصف مشكلتك أو اقتراحك في جملة واحدة',
  'feedback.form.title.required': 'يرجى إدخال عنوان',
  'feedback.form.content.label': 'وصف مفصل',
  'feedback.form.content.placeholder': 'يرجى وصف الخلفية، خطوات إعادة الإنتاج أو الاقتراحات المحددة...',
  'feedback.form.content.required': 'يرجى إدخال محتوى مفصل',
  'feedback.form.attachment.label': 'المرفقات (اختياري)',
  'feedback.upload.dragText': 'انقر أو اسحب الملفات هنا للتحميل',
  'feedback.upload.hint': 'يدعم تنسيقات JPG و PNG و PDF وغيرها، حجم ملف واحد لا يتجاوز 5MB',
  'feedback.upload.sizeLimit': 'لا يمكن أن يتجاوز حجم الملف 5MB',
  'feedback.form.priority.label': 'الأولوية',
  'feedback.priority.low.label': 'منخفضة',
  'feedback.priority.low.desc': 'لا يؤثر على الاستخدام',
  'feedback.priority.medium.label': 'متوسطة',
  'feedback.priority.medium.desc': 'يؤثر على تجربة المستخدم',
  'feedback.priority.high.label': 'عالية',
  'feedback.priority.high.desc': 'يعيق الاستخدام بشكل خطير',
  'feedback.form.contact.label': 'معلومات الاتصال (اختياري)',
  'feedback.form.contact.placeholder': 'البريد الإلكتروني أو رقم الهاتف',
  'feedback.form.submit': 'إرسال الملاحظات',
  'feedback.submit.error': 'فشل الإرسال، يرجى المحاولة مرة أخرى لاحقاً',
  'feedback.success.title': 'تم استلام الملاحظات!',
  'feedback.success.description': 'شكراً لملاحظاتك القيمة. سيقوم فريق المنتج لدينا بقراءة كل ملاحظة بعناية. إذا كان تقرير خطأ، قد نتصل بك من خلال معلومات الاتصال المقدمة.',
  'feedback.success.back': 'رجوع',
  'feedback.success.another': 'إرسال آخر',
  // صفحة الدعوة
  'invite.partnerProgram': 'برنامج الشركاء',
  'invite.title.line1': 'ادعُ أصدقاءك',
  'invite.title.line2': 'اخلق قيمة لا حدود لها',
  'invite.reward.inviter': 'احصل على مكافأة نقدية {amount} لكل صديق تدعوه.',
  'invite.reward.invitee': 'يحصل صديقك على مكافأة ترحيبية {amount} عند التسجيل.',
  'invite.step1.title': '1. شارك الرابط',
  'invite.step1.desc': 'شارك رابطك الحصري عبر وسائل التواصل الاجتماعي',
  'invite.step2.title': '2. تفعيل الصديق',
  'invite.step2.desc': 'يكمل الصديق التسجيل والتحقق',
  'invite.step3.title': '3. اسحب أرباحك',
  'invite.step3.desc': 'أرباح فورية، سحب إلى الرصيد',
  'invite.exclusiveCode': 'رمزك الحصري',
  'invite.copyCode': 'نسخ الرمز',
  'invite.viewQrcode': 'عرض رمز QR',
  'invite.stats.totalInvites': 'إجمالي الدعوات',
  'invite.stats.availableReward': 'الرصيد المتاح',
  'invite.stats.totalReward': 'إجمالي الأرباح',
  'invite.withdrawNow': 'اسحب الآن',
  'invite.history.title': 'سجل الدعوات',
  'invite.filter.all': 'الكل',
  'invite.filter.active': 'نشط',
  'invite.filter.pending': 'معلق',
  'invite.status.credited': 'تم الإضافة',
  'invite.status.pending': 'معلق',
  'invite.history.empty': 'لا توجد سجلات',
  'invite.withdraw.title': 'سحب الأرباح',
  'invite.withdraw.cancel': 'إلغاء',
  'invite.withdraw.confirm': 'تأكيد السحب',
  'invite.withdraw.amount': 'مبلغ السحب',
  'invite.withdraw.note': '* سيتم تحويل المبلغ مباشرة إلى رصيد حسابك.',
  'invite.withdraw.enterAmount': 'يرجى إدخال مبلغ السحب',
  'invite.withdraw.insufficientBalance': 'رصيد غير كافٍ',
  'invite.withdraw.success': 'تم سحب ¥{amount} بنجاح إلى الرصيد',
  'invite.qrcode.title': 'امسح للانضمام',
  'invite.copyLink': 'نسخ الرابط',
  'invite.copy.success': 'تم النسخ بنجاح',
  // قسم البطل في الصفحة الرئيسية
  'home.hero.badge': 'مساعد ذكي · رفيق · شريك',
  'home.hero.title': 'AIMATEX',
  'home.hero.subtitle': 'زميلك في الفصل، رفيق روحك، زميلك في الفريق',
  'home.hero.description': 'AIMATEX هو مساعدك الذكي، وشريكك في التعلم، ورفيقك الإبداعي. نقدم حلول ذكاء اصطناعي شاملة، مما يجعل الذكاء الاصطناعي أفضل شريك لك في العمل والدراسة والإبداع. سواء كان التعلم في الفصل الدراسي، أو التعاون الإبداعي، أو العمل الجماعي، AIMATEX هو شريكك الموثوق.',
  'home.hero.cta.signup': 'ابدأ مجاناً',
  'home.hero.cta.login': 'تسجيل الدخول',
  'home.hero.cta.workspace': 'الذهاب إلى مساحة العمل',
  // قسم المنتجات في الصفحة الرئيسية
  'home.products.title': 'منتجاتنا',
  'home.products.subtitle': 'استكشف منتجات الذكاء الاصطناعي المبتكرة تحت AIMATEX، كل منتج هو أفضل شريك لك في سيناريوهات مختلفة',
  'home.products.seedance2.name': 'Seedance2',
  'home.products.seedance2.description': 'شريك إنشاء صورة إلى فيديو بالذكاء الاصطناعي، يحول الصور الثابتة إلى فيديوهات ديناميكية، مما يعطي الحياة لإبداعك',
  'home.products.ai2obj.name': 'AI2Obj',
  'home.products.ai2obj.description': 'منصة إنشاء وتحويل كائنات ثلاثية الأبعاد مدعومة بالذكاء الاصطناعي، شريكك في الإبداع ثلاثي الأبعاد',
  'home.products.openrobotx.name': 'OpenRobotX',
  'home.products.openrobotx.description': 'استكشف شركات الروبوتات البشرية العالمية، ومقارنات المعاملات ورؤى الصناعة، شريكك في أبحاث الروبوتات',
  'home.products.openclaw4j.name': 'OpenClaw4j',
  'home.products.openclaw4j.title': 'OpenClaw4j',
  'home.products.openclaw4j.description': 'منصة الوكلاء المستقلين — بناء ونشر وكلاء أذكياء مع OpenForgeX.',
  'home.products.openclaw4j.cta': 'تجربة الوكيل',
  'home.products.aimatexMusic.name': 'AIMATEX-MUSIC',
  'home.products.aimatexMusic.title': 'AIMATEX-MUSIC',
  'home.products.aimatexMusic.description': 'مساحة موسيقى سحابية شخصية — اكتشف المقاطع وقوائم التشغيل المشتركة والتشغيل الآن والمكتبة السحابية',
  'home.products.aimatexMusic.cta': 'دخول الموسيقى',
  'home.music.eyebrow': 'مجموعة AIMATEX',
  'home.music.title': 'AIMATEX-MUSIC',
  'home.music.subtitle': 'مساحتك الموسيقية السحابية — اكتشف واجمع واستمع معاً.',
  'home.music.feature.discover.title': 'اكتشف',
  'home.music.feature.discover.desc': 'ابحث واستورد المقاطع إلى مكتبتك السحابية.',
  'home.music.feature.playlist.title': 'قوائم التشغيل',
  'home.music.feature.playlist.desc': 'أنشئ وشارك قوائم تشغيل مشتركة.',
  'home.music.feature.nowPlaying.title': 'قيد التشغيل',
  'home.music.feature.nowPlaying.desc': 'استماع متزامن ومفضلة وسجل.',
  'home.music.feature.cloud.title': 'مكتبة سحابية',
  'home.music.feature.cloud.desc': 'صوت عالي الجودة محفوظ في السحابة.',
  'home.music.cta': 'فتح AIMATEX-MUSIC',
'home.showcase.seedance2.eyebrow': 'Image to Video',
  'home.showcase.seedance2.title': 'Seedance2',
  'home.showcase.seedance2.subtitle': 'Turn still frames into cinematic motion with a next-gen creation engine.',
  'home.showcase.seedance2.f1.title': 'Image to Video',
  'home.showcase.seedance2.f1.desc': 'Upload a photo — AI invents light and motion.',
  'home.showcase.seedance2.f2.title': 'Cinema Quality',
  'home.showcase.seedance2.f2.desc': 'High-res output with stable, crisp detail.',
  'home.showcase.seedance2.f3.title': 'Smart Prompts',
  'home.showcase.seedance2.f3.desc': 'AI polishes rough ideas into film-ready prompts.',
  'home.showcase.seedance2.f4.title': 'Style Switch',
  'home.showcase.seedance2.f4.desc': 'Cyberpunk, oil paint, anime — one click.',
  'home.showcase.seedance2.cta': 'Enter Seedance2',
  'home.showcase.ai2obj.eyebrow': '3D Generation',
  'home.showcase.ai2obj.title': 'AI2Obj',
  'home.showcase.ai2obj.subtitle': 'An AI generation platform that turns ideas into usable digital assets.',
  'home.showcase.ai2obj.f1.title': 'Multimodal',
  'home.showcase.ai2obj.f1.desc': 'From text and images to 3D and content assets.',
  'home.showcase.ai2obj.f2.title': 'Object Convert',
  'home.showcase.ai2obj.f2.desc': 'Structure understanding and format conversion.',
  'home.showcase.ai2obj.f3.title': 'Creator Workflow',
  'home.showcase.ai2obj.f3.desc': 'Pipelines built for product and content teams.',
  'home.showcase.ai2obj.f4.title': 'Cloud Delivery',
  'home.showcase.ai2obj.f4.desc': 'Preview, export, and collaborate in the cloud.',
  'home.showcase.ai2obj.cta': 'Visit AI2Obj',
  'home.showcase.openrobotx.eyebrow': 'Robotics Intel',
  'home.showcase.openrobotx.title': 'OpenRobotX',
  'home.showcase.openrobotx.subtitle': 'Global humanoid robot companies, specs, and industry insights in one place.',
  'home.showcase.openrobotx.f1.title': 'World Map',
  'home.showcase.openrobotx.f1.desc': 'Major humanoid vendors and products covered.',
  'home.showcase.openrobotx.f2.title': 'Spec Compare',
  'home.showcase.openrobotx.f2.desc': 'Clear side-by-side capability and positioning.',
  'home.showcase.openrobotx.f3.title': 'Industry News',
  'home.showcase.openrobotx.f3.desc': 'Funding, launches, and tech movements tracked.',
  'home.showcase.openrobotx.f4.title': 'Research Partner',
  'home.showcase.openrobotx.f4.desc': 'Structured intel for selection and research.',
  'home.showcase.openrobotx.cta': 'Explore OpenRobotX',
  'home.showcase.openclaw4j.eyebrow': 'Autonomous Agents',
  'home.showcase.openclaw4j.title': 'OpenClaw4j',
  'home.showcase.openclaw4j.subtitle': 'Build and deploy intelligent agents with OpenForgeX — make agents run for real.',
  'home.showcase.openclaw4j.f1.title': 'Agent Orchestration',
  'home.showcase.openclaw4j.f1.desc': 'Multi-step planning and execution.',
  'home.showcase.openclaw4j.f2.title': 'Tool Calling',
  'home.showcase.openclaw4j.f2.desc': 'Connect APIs and business systems.',
  'home.showcase.openclaw4j.f3.title': 'Observable Runs',
  'home.showcase.openclaw4j.f3.desc': 'Transparent traces for debug and iteration.',
  'home.showcase.openclaw4j.f4.title': 'One-click Deploy',
  'home.showcase.openclaw4j.f4.desc': 'From prototype to live service fast.',
  'home.showcase.openclaw4j.cta': 'Try Agent',
  'home.products.learnMore': 'معرفة المزيد',
  // قسم ميزات الصفحة الرئيسية
  'home.features.title': 'ورشة إبداعية متكاملة.',
  'home.features.subtitle': 'أكثر من مجرد توليد فيديو، إنها تمكين إبداعي شامل.',
  'home.features.aiPrompt.title': 'لا تستطيع كتابة المطالبات؟ الذكاء الاصطناعي يكتب لك',
  'home.features.aiPrompt.description': 'لا توجد أفكار على الإطلاق؟ دع الذكاء الاصطناعي يكتب لك بنقرة واحدة. اكتب بضع كلمات فقط، يقوم الذكاء الاصطناعي بصقلها تلقائياً إلى أوصاف سينمائية، 10 ثوانٍ للإنتاج. تريد تغيير الأسلوب؟ انقر مرة أخرى، تحول فوري إلى سايبربانك/رسم زيتي/أنمي.',
  'home.features.demo.userInput': 'قطة',
  'home.features.demo.aiResult': 'قطة فارسية أنيقة بفرو أبيض طويل ناعم ورقيق وعيون عنبرية، جالسة على حافة نافذة مشمسة. الخلفية تتميز بسماء زرقاء فاتحة وستائر بيضاء متدفقة. 4K عالية الدقة، إضاءة سينمائية، عمق المجال، تصوير احترافي.',
  'home.features.demo.buttonText': 'توليد بالذكاء الاصطناعي',
  'home.features.demo.buttonLoading': 'جاري التوليد',
  'home.features.demo.thinkingText': 'الذكاء الاصطناعي يبدع✨',
  'home.features.quality.title': 'جودة سينمائية',
  'home.features.quality.description': 'دعم أصلي لإخراج بدقة 4K، كل إطار مصمم بعناية.',
  'home.features.imageToVideo.title': 'صورة إلى فيديو',
  'home.features.imageToVideo.description': 'قم بتحميل صورة ثابتة، يفهم الذكاء الاصطناعي الإضاءة والفيزياء في المشهد، يولد تلقائياً ديناميكيات لاحقة، مما يجعل الصور تنبض بالحياة.',
  'home.features.multimodal.title': 'نظام بيئي متعدد الوسائط',
  'home.features.multimodal.description': 'لا يدعم فقط Stable Diffusion من نص إلى صورة، بل يدمج أيضاً نقل أسلوب Midjourney وتركيب صوت ElevenLabs. أكمل جميع الإبداعات في سير عمل واحد.',
  
  // قسم المجتمع في الصفحة الرئيسية
  'home.community.title': 'استكشف مجتمعات الإبداع بالذكاء الاصطناعي',
  'home.community.subtitle': 'انضم إلى الملايين من المبدعين، شارك تحفك الفنية بالذكاء الاصطناعي واحصل على الإلهام والتعليقات',
  'home.community.hot': 'شائع',
  'home.community.explore': 'استكشف المجتمع',
  'home.community.stats.works': 'الأعمال',
  'home.community.stats.creators': 'المبدعون',
  'home.community.stats.views': 'المشاهدات',
  'home.community.image.title': 'مجتمع صور الذكاء الاصطناعي',
  'home.community.image.description': 'اكتشف وشارك صوراً مذهلة تم إنشاؤها بالذكاء الاصطناعي، من الواقعية الفوتوغرافية إلى الفنية، من الرسوم التوضيحية إلى التصوير الفوتوغرافي',
  'home.community.video.title': 'مجتمع فيديو الذكاء الاصطناعي',
  'home.community.video.description': 'استكشف مقاطع فيديو رائعة تم إنشاؤها بالذكاء الاصطناعي، تعلم تقنيات إبداعية وتبادل الخبرات مع صناع الفيديو العالميين',
  'home.community.music.title': 'مجتمع موسيقى الذكاء الاصطناعي',
  'home.community.music.description': 'استمع إلى ألحان جميلة مؤلفة بالذكاء الاصطناعي، شارك أعمالك الموسيقية وابحث عن عشاق الموسيقى ذوي التفكير المماثل',
  'home.community.3d.title': 'مجتمع نماذج 3D بالذكاء الاصطناعي',
  'home.community.3d.description': 'استكشف عالم النماذج ثلاثية الأبعاد المُنشأة بالذكاء الاصطناعي، من الهندسة المعمارية إلى الشخصيات، من الألعاب إلى التصميم الصناعي',
  'home.community.voice.title': 'مجتمع الصوت بالذكاء الاصطناعي',
  'home.community.voice.description': 'جرب تركيب الصوت الواقعي بالذكاء الاصطناعي، الدبلجة، الكتب الصوتية، استنساخ الصوت وأضف الحياة لإبداعاتك',
  'home.community.text.title': 'مجتمع النص بالذكاء الاصطناعي',
  'home.community.text.description': 'شارك نصوصاً ممتازة أنشأها الذكاء الاصطناعي، روايات، قصائد، سيناريوهات، كتابة إعلانية وألهم إبداعك الأدبي',
  
  // صفحة الفواتير
  'billing.page.title': 'المركز المالي',
  'billing.page.description': 'إدارة معاملاتك وتفاصيل الفواتير',
  'billing.button.refresh': 'تحديث',
  'billing.button.recharge': 'إعادة الشحن',
  'billing.button.reset': 'إعادة تعيين',
  'billing.button.apply': 'تطبيق الفلاتر',
  'billing.balance.cny': 'رصيد CNY',
  'billing.balance.usdt': 'رصيد USDT',
  'billing.balance.usd': 'رصيد USD',
  'billing.balance.token': 'رصيد الرموز',
  'billing.balance.frozen': 'مجمد',
  'billing.type.frozen': 'أموال مجمدة',
  'billing.type.aiModelFee': 'رسوم نموذج الذكاء الاصطناعي',
  'billing.type.recharge': 'إعادة الشحن',
  'billing.type.refund': 'استرداد',
  'billing.type.reward': 'مكافأة',
  'billing.type.all': 'جميع الأنواع',
  'billing.coin.all': 'جميع العملات',
  'billing.coin.usdt': 'USDT',
  'billing.coin.cny': 'CNY',
  'billing.coin.usd': 'USD',
  'billing.coin.token': 'TOKEN',
  'billing.table.type': 'النوع',
  'billing.table.coinType': 'العملة',
  'billing.table.time': 'الوقت',
  'billing.table.amount': 'المبلغ',
  'billing.table.remark': 'ملاحظة',
  'billing.table.balance': 'الرصيد',
  'billing.table.empty': 'لا توجد سجلات',
  'billing.filter.title': 'خيارات التصفية',
  'billing.filter.button': 'التصفية والتاريخ',
  'billing.filter.changeType': 'نوع المعاملة',
  'billing.filter.coinType': 'نوع العملة',
  'billing.filter.remark': 'البحث عن ملاحظة',
  'billing.filter.remarkPlaceholder': 'أدخل الكلمات الرئيسية',
  'billing.filter.remarkSearch': 'البحث عن ملاحظة',
  'billing.filter.dateQuick': 'تاريخ سريع',
  'billing.filter.dateCustom': 'تاريخ مخصص',
  'billing.filter.dateTo': 'إلى',
  'billing.filter.days7': 'آخر 7 أيام',
  'billing.filter.days30': 'آخر 30 يوماً',
  'billing.filter.days90': 'آخر 3 أشهر',
  'billing.placeholder.changeType': 'نوع التغيير',
  'billing.placeholder.coinType': 'العملة',
  'billing.placeholder.remark': 'البحث عن ملاحظة',
  'billing.message.fetchBalanceError': 'فشل في جلب الرصيد',
  'billing.message.fetchRecordsError': 'فشل في جلب سجلات الفواتير',
  'billing.message.tryAgain': 'فشل في جلب سجلات الفواتير، يرجى المحاولة لاحقاً',
  
  // صفحة إعادة الشحن
  'recharge.page.title': 'إعادة شحن الحساب',
  'recharge.page.backLink': 'العودة إلى الفواتير',
  'recharge.balance.title': 'رصيد الحساب',
  'recharge.balance.refresh': 'تحديث',
  'recharge.section.coinType': 'عملة إعادة الشحن',
  'recharge.section.paymentMethod': 'طريقة الدفع',
  'recharge.section.amount': 'مبلغ إعادة الشحن',
  'recharge.order.title': 'تفاصيل الطلب',
  'recharge.order.type': 'نوع إعادة الشحن',
  'recharge.order.typeValue': 'إعادة شحن رصيد الحساب',
  'recharge.order.account': 'الحساب',
  'recharge.order.accountLoading': 'جارٍ التحميل...',
  'recharge.order.paymentMethod': 'طريقة الدفع',
  'recharge.order.paymentMethodPlease': 'يرجى الاختيار',
  'recharge.order.total': 'المبلغ الإجمالي',
  'recharge.button.pay': 'ادفع الآن',
  'recharge.button.customize': 'مبلغ مخصص',
  'recharge.placeholder.customAmount': 'أدخل مبلغاً مخصصاً',
  'recharge.security.ssl': 'نقل مشفر SSL، دفع آمن',
  'recharge.security.agreement': 'بالنقر على "ادفع"، فإنك توافق على',
  'recharge.security.agreementLink': 'اتفاقية خدمة إعادة الشحن',
  'recharge.empty.noCurrency': 'لا توجد عملات مدعومة',
  'recharge.empty.noPaymentMethod': 'لا توجد طريقة دفع متاحة لـ {currency}',
  'recharge.empty.pleaseSelectCurrency': 'يرجى اختيار العملة أولاً',
  'recharge.empty.pleaseSelectPayment': 'يرجى اختيار طريقة الدفع أولاً',
  'recharge.empty.noProducts': 'لا توجد منتجات متاحة',
  'recharge.empty.noPresets': 'لا توجد مبالغ محددة مسبقاً لـ {currency}',
  'recharge.message.invalidAmount': 'يرجى إدخال مبلغ صالح',
  'recharge.message.selectPaymentMethod': 'يرجى اختيار طريقة دفع',
  'recharge.message.selectAmount': 'يرجى اختيار مبلغ إعادة الشحن',
  'recharge.message.fetchBalanceError': 'فشل في جلب الرصيد، يرجى المحاولة لاحقاً',
  'recharge.message.fetchUserInfoError': 'فشل في جلب معلومات المستخدم',
  'recharge.message.fetchCurrenciesError': 'فشل في جلب العملات، يرجى المحاولة لاحقاً',
  'recharge.message.fetchPaymentMethodsError': 'فشل في جلب طرق الدفع، يرجى المحاولة لاحقاً',
  'recharge.message.fetchCreemProductsError': 'فشل في جلب منتجات Creem، يرجى المحاولة لاحقاً',
  'recharge.message.fetchCreemProductsWarning': 'فشل في جلب منتجات Creem',
  'recharge.message.orderCreated': 'تم إنشاء الطلب بنجاح',
  'recharge.message.orderCreateFailed': 'فشل في إنشاء طلب إعادة الشحن',
  'recharge.message.paymentProcessing': 'فتح صفحة الدفع، يرجى إكمال الدفع...',
  'recharge.message.popupBlocked': 'لا يمكن فتح نافذة الدفع، يرجى التحقق من إعدادات النوافذ المنبثقة في المتصفح',
  'recharge.message.paymentUrlError': 'فشل في الحصول على رابط الدفع',
  'recharge.message.checkoutSessionError': 'فشل في إنشاء جلسة الدفع',
  'recharge.message.paymentError': 'فشلت معالجة الدفع، يرجى المحاولة لاحقاً',
  'recharge.message.redirecting': 'إعادة التوجيه إلى صفحة الدفع، يرجى إكمال الدفع...',
  'recharge.message.paymentUrlFailed': 'رابط الدفع غير متاح',
  'recharge.message.paymentSuccess': 'تم الدفع بنجاح! تم تحديث الرصيد',
  'recharge.message.orderCancelled': 'تم إلغاء الطلب',
  'recharge.message.paymentFailed': 'فشل الدفع',
  'recharge.message.orderExpired': 'منتهي الصلاحية',
  'recharge.message.queryOrderError': 'فشل في الاستعلام عن حالة الطلب',
  'recharge.message.rechargeError': 'فشل طلب إعادة الشحن، يرجى المحاولة لاحقاً',

  // صفحة الطلبات
  'orders.title': 'سجل الطلبات',
  'orders.subtitle': 'عرض جميع سجلات طلبات الشحن والحالة',
  'orders.refresh': 'تحديث',
  'orders.goToRecharge': 'شحن',

  // بطاقات الإحصائيات
  'orders.stats.totalOrders': 'إجمالي الطلبات',
  'orders.stats.pending': 'قيد الانتظار',
  'orders.stats.paid': 'مدفوع',
  'orders.stats.totalAmount': 'إجمالي المبلغ المشحون',

  // أعمدة الجدول
  'orders.table.orderNo': 'رقم الطلب',
  'orders.table.createTime': 'تاريخ الإنشاء',
  'orders.table.amount': 'المبلغ',
  'orders.table.paymentMethod': 'طريقة الدفع',
  'orders.table.status': 'الحالة',
  'orders.table.action': 'الإجراء',
  'orders.table.view': 'عرض',
  'orders.table.cancel': 'إلغاء',
  'orders.table.empty': 'لا توجد سجلات طلبات',

  // حالة الطلب
  'orders.status.pending': 'قيد الانتظار',
  'orders.status.paid': 'مدفوع',
  'orders.status.success': 'مكتمل',
  'orders.status.cancelled': 'ملغى',
  'orders.status.failed': 'فشل',
  'orders.status.expired': 'منتهي الصلاحية',
  'orders.status.all': 'جميع الحالات',

  // طرق الدفع
  'orders.payment.alipay': 'Alipay',
  'orders.payment.wechat': 'WeChat Pay',
  'orders.payment.bank': 'بطاقة بنكية',
  'orders.payment.usdt': 'USDT',
  'orders.payment.creem': 'Creem',
  'orders.payment.all': 'جميع الطرق',

  // العملة
  'orders.coin.all': 'جميع العملات',

  // الفلاتر
  'orders.filter.title': 'خيارات التصفية',
  'orders.filter.button': 'تصفية الطلبات',
  'orders.filter.reset': 'إعادة تعيين',
  'orders.filter.apply': 'تطبيق',
  'orders.filter.orderStatus': 'حالة الطلب',
  'orders.filter.paymentMethod': 'طريقة الدفع',
  'orders.filter.coinType': 'نوع العملة',
  'orders.filter.orderNoSearch': 'البحث عن رقم الطلب',
  'orders.filter.quickDate': 'تاريخ سريع',
  'orders.filter.customDate': 'تاريخ مخصص',
  'orders.filter.dateTo': 'إلى',
  'orders.filter.last7Days': 'آخر 7 أيام',
  'orders.filter.last30Days': 'آخر 30 يوم',
  'orders.filter.last3Months': 'آخر 3 أشهر',

  // البحث والإدخال
  'orders.search.placeholder': 'البحث عن رقم الطلب',
  'orders.input.orderNo': 'أدخل رقم الطلب',
  'orders.select.orderStatus': 'حالة الطلب',
  'orders.select.paymentMethod': 'طريقة الدفع',
  'orders.select.coinType': 'العملة',

  // الرسائل
  'orders.message.fetchError': 'فشل في جلب الطلبات',
  'orders.message.fetchErrorRetry': 'فشل في جلب الطلبات، يرجى المحاولة لاحقاً',
  'orders.message.statsError': 'فشل في جلب الإحصائيات',
  'orders.message.cancelSuccess': 'تم إلغاء الطلب',
  'orders.message.cancelError': 'فشل في إلغاء الطلب',
  'orders.message.cancelErrorRetry': 'فشل في إلغاء الطلب، يرجى المحاولة لاحقاً',
  'orders.message.viewOrder': 'رقم الطلب: {orderNo}',

  // مربع الحوار التأكيد
  'orders.confirm.cancel': 'هل أنت متأكد من إلغاء هذا الطلب؟',
  'orders.confirm.ok': 'موافق',
  'orders.confirm.cancelButton': 'إلغاء',

  // صفحة انضم إلينا
  'joinUs.seo.title': 'انضم إلى PROTX - السعي نحو الكمال',
  'joinUs.seo.description': 'انضم إلى فريق PROTX واسعَ معنا نحو تجربة المستخدم وتصميم المنتج المثاليين',
  'joinUs.hero.eyebrow': 'JOIN PROTX',
  'joinUs.hero.title': 'السعي نحو الكمال',
  'joinUs.hero.title2': 'تحديد المستقبل من خلال التصميم',
  'joinUs.hero.subtitle': 'PROTX هو فريق مكرس لخلق تجربة المستخدم وتصميم المنتج المثاليين. نؤمن بأن كل بكسل له أهمية، وكل تفاعل يستحق أن يُصقل بدقة. إذا كنت تشاركنا سعينا الدؤوب نحو التميز، انضم إلينا.',
  'joinUs.hero.cta': 'عرض الوظائف المتاحة',
  'joinUs.hero.video': 'شاهد قصتنا',
  
  'joinUs.values.eyebrow': 'قيمنا',
  'joinUs.values.title': 'قيمنا الأساسية',
  'joinUs.values.subtitle': 'هذه القيم الأساسية تحدد من نحن وكيف نعمل معًا',
  'joinUs.values.innovation.title': 'مدفوع بالابتكار',
  'joinUs.values.innovation.desc': 'نؤمن بأن الابتكار هو القوة التي تغير العالم، نشجع كل فكرة رائدة.',
  'joinUs.values.collaboration.title': 'النجاح التعاوني',
  'joinUs.values.collaboration.desc': 'تعاون بين الفرق لخلق نتائج استثنائية معًا.',
  'joinUs.values.excellence.title': 'السعي للتميز',
  'joinUs.values.excellence.desc': 'تجاوز الحدود باستمرار للحصول على تجربة مثالية.',
  'joinUs.values.passion.title': 'الشغف والتركيز',
  'joinUs.values.passion.desc': 'حب التكنولوجيا، التفاني في المنتج.',
  'joinUs.values.impact.title': 'إحداث تأثير',
  'joinUs.values.impact.desc': 'تمكين التعبير الإبداعي للجميع من خلال تقنية الذكاء الاصطناعي.',
  
  'joinUs.positions.eyebrow': 'الوظائف المتاحة',
  'joinUs.positions.title': 'الوظائف المتاحة',
  'joinUs.positions.subtitle': 'ابحث عن الدور المناسب لك وابدأ رحلتك المهنية الجديدة',
  'joinUs.category.engineering': 'الهندسة',
  'joinUs.category.product': 'المنتج والتصميم',
  'joinUs.category.operations': 'العمليات والتسويق',
  'joinUs.position.seniorFrontend': 'مهندس Frontend أول',
  'joinUs.position.backendEngineer': 'مهندس Backend',
  'joinUs.position.mlEngineer': 'مهندس AI/ML',
  'joinUs.position.productManager': 'مدير المنتج',
  'joinUs.position.uxDesigner': 'مصمم UX',
  'joinUs.position.communityManager': 'مدير المجتمع',
  'joinUs.position.contentCreator': 'منشئ المحتوى',
  'joinUs.location.remote': 'عن بُعد',
  'joinUs.location.beijing': 'بكين',
  'joinUs.location.shanghai': 'شنغهاي',
  'joinUs.location.shenzhen': 'شنتشن',
  'joinUs.type.fulltime': 'دوام كامل',
  'joinUs.type.parttime': 'دوام جزئي',
  
  'joinUs.benefits.eyebrow': 'المزايا',
  'joinUs.benefits.title': 'ما نقدمه',
  'joinUs.benefits.subtitle': 'انضم إلينا واستمتع بمزايا ودعم شاملين',
  'joinUs.benefit.flexible.title': 'عمل مرن',
  'joinUs.benefit.flexible.desc': 'ساعات عمل مرنة وخيارات العمل عن بُعد',
  'joinUs.benefit.equity.title': 'خيارات الأسهم',
  'joinUs.benefit.equity.desc': 'انمو مع الشركة وشارك في نجاحنا',
  'joinUs.benefit.health.title': 'تأمين صحي',
  'joinUs.benefit.health.desc': 'تأمين صحي شامل ومزايا العافية',
  'joinUs.benefit.growth.title': 'نمو مهني',
  'joinUs.benefit.growth.desc': 'فرص تعلم وتطوير مستمرة',
  
  'joinUs.cta.title': 'هل أنت مستعد للبدء؟',
  'joinUs.cta.subtitle': 'إذا كنت شغوفًا بمهمتنا، نتطلع لسماع منك',
  'joinUs.cta.button': 'قدم الآن',
  
  'joinUs.modal.title': 'طلب التوظيف',
  'joinUs.apply.success': 'تم تقديم الطلب! سنتواصل معك قريبًا.',
  'joinUs.form.name': 'الاسم',
  'joinUs.form.name.required': 'الرجاء إدخال اسمك',
  'joinUs.form.name.placeholder': 'أدخل اسمك',
  'joinUs.form.email': 'البريد الإلكتروني',
  'joinUs.form.email.required': 'الرجاء إدخال بريدك الإلكتروني',
  'joinUs.form.email.invalid': 'الرجاء إدخال بريد إلكتروني صالح',
  'joinUs.form.email.placeholder': 'أدخل بريدك الإلكتروني',
  'joinUs.form.phone': 'رقم الهاتف',
  'joinUs.form.phone.placeholder': 'أدخل رقم هاتفك',
  'joinUs.form.experience': 'الخبرة العملية',
  'joinUs.form.experience.placeholder': 'اختر مستوى خبرتك',
  'joinUs.form.experience.0-2': '0-2 سنوات',
  'joinUs.form.experience.3-5': '3-5 سنوات',
  'joinUs.form.experience.5-10': '5-10 سنوات',
  'joinUs.form.experience.10+': '10+ سنوات',
  'joinUs.form.resume': 'السيرة الذاتية',
  'joinUs.form.resume.hint': 'انقر أو اسحب الملف للتحميل',
  'joinUs.form.resume.format': 'تدعم صيغ PDF، DOC، DOCX',
  'joinUs.form.message': 'خطاب التغطية',
  'joinUs.form.message.placeholder': 'أخبرنا عن نفسك ولماذا تريد الانضمام إلينا',
  'joinUs.form.submit': 'تقديم الطلب',
  'joinUs.form.loginTip': 'سجل الدخول قبل الإرسال لتتبع طلبك',
  'joinUs.form.goLogin': 'تسجيل الدخول',
  'joinUs.form.resume.sizeLimit': 'حجم الملف لا يمكن أن يتجاوز 10 ميجابايت',
  
  // طلباتي
  'joinUs.myApplications.eyebrow': 'طلباتي',
  'joinUs.myApplications.title': 'سجل الطلبات',
  'joinUs.myApplications.empty': 'لا توجد طلبات بعد. أرسل سيرتك الذاتية الآن!',
  'joinUs.myApplications.viewDetail': 'عرض التفاصيل',
  'joinUs.myApplications.detailTitle': 'تفاصيل الطلب',
  'joinUs.status.pending': 'قيد الانتظار',
  'joinUs.status.reviewing': 'قيد المراجعة',
  'joinUs.status.interview': 'مقابلة',
  'joinUs.status.accepted': 'مقبول',
  'joinUs.status.rejected': 'مرفوض',
  'joinUs.detail.basicInfo': 'المعلومات الأساسية',
  'joinUs.detail.positionInfo': 'معلومات الوظيفة',
  'joinUs.detail.position': 'الوظيفة المطلوبة',
  'joinUs.detail.category': 'الفئة',
  'joinUs.detail.location': 'الموقع',
  'joinUs.detail.applyTime': 'تاريخ التقديم',
  'joinUs.detail.downloadResume': 'تحميل السيرة الذاتية',
  'joinUs.detail.status': 'حالة الطلب',

  // ===== المفاتيح المفقودة =====

  // التسجيل/تسجيل الدخول
  'signup.error.allFieldsRequired': 'يرجى ملء جميع الحقول المطلوبة',
  'signup.error.emailInvalid': 'يرجى إدخال عنوان بريد إلكتروني صالح',
  'login.verificationCode.placeholder': 'أدخل رمز التحقق',
  'login.verificationCode.send': 'الحصول على الرمز',
  'login.verificationCode.sending': 'جاري الإرسال...',
  'login.verificationCode.retry': 'أعد المحاولة بعد {seconds} ثانية',
  'login.verificationCode.success': 'تم إرسال رمز التحقق',
  'login.verificationCode.error': 'فشل في إرسال رمز التحقق',
  'login.verificationCode.required': 'يرجى إدخال رمز التحقق',
  'login.verificationCode.invalid': 'تنسيق رمز التحقق غير صالح',

  // خطوات فك التشفير
  'decrypt.steps.title': 'خطوات فك التشفير',
  'decrypt.steps.items': [
    {
      title: 'اختيار الملف المشفر',
      description: 'اختر ملفات .encrypted المشفرة بأداة AIMATEX، يدعم السحب والإفلات أو النقر للاختيار'
    },
    {
      title: 'إدخال كلمة مرور فك التشفير',
      description: 'أدخل كلمة المرور المحددة أثناء التشفير، سيتم استخدامها فقط لفك التشفير المحلي ولن يتم نقلها أو تخزينها'
    },
    {
      title: 'بدء فك التشفير',
      description: 'بعد النقر على الزر، سيستخدم النظام خوارزمية AES-256-CBC لفك تشفير ملفك محلياً'
    },
    {
      title: 'الحصول على الملف الأصلي',
      description: 'بعد اكتمال فك التشفير، سيتم تنزيل الملف الأصلي تلقائياً، عملية فك التشفير بدون فقدان تضمن سلامة الملف'
    }
  ],

  // معلومات الملف
  'decrypt.fileInfo.modal.title': 'معلومات الملف',
  'decrypt.fileInfo.modal.close': 'إغلاق',
  'decrypt.fileInfo.name': 'اسم الملف',
  'decrypt.fileInfo.size': 'حجم الملف',
  'decrypt.fileInfo.type': 'نوع الملف',
  'decrypt.fileInfo.lastModified': 'آخر تعديل',
  'decrypt.fileInfo.status': 'الحالة',
  'decrypt.fileInfo.progress': 'التقدم',
  'decrypt.fileInfo.speed': 'السرعة',
  'decrypt.fileInfo.timeRemaining': 'الوقت المتبقي',
  'decrypt.fileInfo.timeSpent': 'الوقت المستغرق',
  'decrypt.fileInfo.error': 'رسالة الخطأ',

  // شرح تفصيلي لخوارزمية AES
  'security.features.modal.title': 'شرح تفصيلي لخوارزمية AES-256-CBC',
  'security.features.aes.what': 'ما هو AES-256-CBC؟',
  'security.features.aes.description': 'AES-256-CBC هو تنفيذ لمعيار التشفير المتقدم (Advanced Encryption Standard)، حيث:',
  'security.features.aes.detail.1': 'خوارزمية تشفير متماثلة، أنشأها المعهد الوطني للمعايير والتكنولوجيا (NIST) في عام 2001',
  'security.features.aes.detail.2': 'يستخدم طول مفتاح 256 بت، يوفر أعلى مستوى من الأمان',
  'security.features.aes.detail.3': 'وضع تسلسل كتلة الشفرة (Cipher Block Chaining)، يوفر أماناً أفضل للتشفير',
  'security.features.aes.how': 'مبدأ العمل',
  'security.features.aes.process': 'عملية تشفير AES-256-CBC تتضمن الخطوات التالية:',
  'security.features.aes.step1': 'تقسيم بيانات النص العادي إلى كتل بحجم ثابت (128 بت)',
  'security.features.aes.step2': 'إنشاء متجه تهيئة (IV) عشوائي',
  'security.features.aes.step3': 'استخدام وضع CBC لإجراء عملية XOR بين كتلة النص المشفر السابقة وكتلة النص العادي الحالية',
  'security.features.aes.step4': 'استخدام مفتاح 256 بت لتشفير AES على نتيجة XOR',
  'security.features.aes.example': 'مثال على عملية التشفير:',
  'security.features.aes.security': 'ميزات الأمان',
  'security.features.aes.security.intro': 'AES-256-CBC يوفر حماية أمان متعددة:',
  'security.features.aes.security.point1': 'مفتاح 256 بت يوفر 2^256 مجموعة ممكنة، حتى باستخدام الحواسيب الفائقة لا يمكن كسرها بالقوة الغاشمة في وقت معقول',
  'security.features.aes.security.point2': 'وضع CBC يضمن أن كتل النص العادي المتماثلة تنتج كتل نص مشفر مختلفة، مما يزيد من عشوائية التشفير',
  'security.features.aes.security.point3': 'استخدام متجه التهيئة (IV) يضمن أنه حتى مع نفس المفتاح، كل عملية تشفير تنتج نتيجة مختلفة',
  'security.features.aes.security.point4': 'يستخدم على نطاق واسع في المجالات العسكرية والمالية وغيرها من المجالات ذات متطلبات الأمان العالية',
  'security.features.aes.diagram': 'مخطط ديناميكي لعملية تشفير وضع CBC',
  'security.features.aes.why': 'لماذا اخترنا AES-256-CBC؟',
  'security.features.aes.why.intro': 'أسباب اختيارنا AES-256-CBC كمعيار تشفير:',
  'security.features.aes.why.point1': 'أمان تم التحقق منه على نطاق واسع، لا توجد طرق هجوم عملية حتى الآن',
  'security.features.aes.why.point2': 'أداء ممتاز، سرعة تشفير وفك تشفير عالية',
  'security.features.aes.why.point3': 'دعم تسريع الأجهزة، المعالجات الرئيسية تحتوي على مجموعة تعليمات AES مدمجة',
  'security.features.aes.why.point4': 'دعم واسع للأدوات، جميع لغات البرمجة لديها تنفيذات ناضجة',

  // فك التشفير الذكي بالكتل
  'security.features.chunk.title': 'شرح تفصيلي لتقنية فك التشفير الذكي بالكتل',
  'security.features.chunk.what': 'ما هو فك التشفير الذكي بالكتل؟',
  'security.features.chunk.description': 'فك التشفير الذكي بالكتل هو تقنية فك تشفير محسنة للملفات الكبيرة، تقسم الملفات الكبيرة إلى كتل صغيرة متعددة للمعالجة المتوازية، مع الميزات التالية:',
  'security.features.chunk.feature1.title': 'تقسيم ديناميكي',
  'security.features.chunk.feature1.desc': 'ضبط حجم الكتلة تلقائياً بناءً على حجم الملف وذاكرة النظام',
  'security.features.chunk.feature2.title': 'معالجة متوازية',
  'security.features.chunk.feature2.desc': 'فك تشفير كتل بيانات متعددة في وقت واحد، استغلال كامل لوحدات المعالجة المركزية متعددة النوى',
  'security.features.chunk.feature3.title': 'تحسين الذاكرة',
  'security.features.chunk.feature3.desc': 'التحكم في استخدام الذاكرة من خلال المعالجة المتدفقة، تجنب تجاوز الذاكرة',
  'security.features.chunk.feature4.title': 'استئناف الانقطاع',
  'security.features.chunk.feature4.desc': 'دعم الاستمرار بعد انقطاع عملية فك التشفير، تحسين التسامح مع الأخطاء',
  'security.features.chunk.how': 'مبدأ العمل',
  'security.features.chunk.process': 'سير عمل فك التشفير الذكي بالكتل كالتالي:',
  'security.features.chunk.step1': 'تحليل الملف المسبق: حساب الحجم الأمثل للكتلة وعددها',
  'security.features.chunk.step2': 'تقسيم البيانات: تقسيم الملف المشفر إلى كتل بيانات متساوية الحجم',
  'security.features.chunk.step3': 'فك التشفير المتوازي: إجراء عمليات فك التشفير على كتل بيانات متعددة في وقت واحد',
  'security.features.chunk.step4': 'الكتابة المتدفقة: كتابة كتل البيانات المفكوكة بالترتيب إلى الملف الهدف',
  'security.features.chunk.code': '{code}',
  'security.features.chunk.performance': 'مزايا الأداء',
  'security.features.chunk.performance.intro': 'مقارنة بفك التشفير الكامل التقليدي، فك التشفير الذكي بالكتل له مزايا كبيرة:',
  'security.features.chunk.performance.point1': 'تقليل استخدام الذاكرة بنسبة تصل إلى 90%، ملف 4GB يحتاج فقط 400MB من الذاكرة',
  'security.features.chunk.performance.point2': 'تحسين سرعة فك التشفير بمقدار 3-5 مرات، استغلال كامل لوحدات المعالجة المركزية متعددة النوى',
  'security.features.chunk.performance.point3': 'دعم فك تشفير الملفات الكبيرة جداً (>4GB)، غير مقيد بذاكرة المتصفح',
  'security.features.chunk.performance.point4': 'تصور عملية فك التشفير، عرض دقيق للتقدم والوقت المتبقي',
  'security.features.chunk.usage': 'سيناريوهات التطبيق',
  'security.features.chunk.usage.intro': 'فك التشفير الذكي بالكتل مناسب بشكل خاص للسيناريوهات التالية:',
  'security.features.chunk.usage.point1': 'فك تشفير الملفات الكبيرة (مثل الفيديو، النسخ الاحتياطية لقاعدة البيانات)',
  'security.features.chunk.usage.point2': 'عمليات فك التشفير على الأجهزة ذات الذاكرة المحدودة (مثل الأجهزة المحمولة)',
  'security.features.chunk.usage.point3': 'فك تشفير دفعي للملفات يتطلب معالجة متوازية',
  'security.features.chunk.usage.point4': 'مهام فك التشفير التي تتطلب تغذية راجعة في الوقت الفعلي للتقدم',
  'security.features.chunk.diagram': 'مخطط سير عمل فك التشفير الذكي بالكتل',

  // مخطط فك التشفير
  'decrypt.diagram.title': 'سير عمل فك التشفير الذكي بالكتل',
  'decrypt.diagram.encryptedFile': 'ملف مشفر',
  'decrypt.diagram.smartChunking': 'تقسيم ذكي',
  'decrypt.diagram.parallelDecryption': 'فك تشفير متوازي',
  'decrypt.diagram.decryptedFile': 'ملف مفكوك',
  'decrypt.diagram.memoryOptimization': 'تحسين استخدام الذاكرة',
  'decrypt.diagram.memoryUsage': 'يستخدم فقط حوالي 10% من مساحة الذاكرة',
  'decrypt.diagram.realTimeFeedback': 'تغذية راجعة في الوقت الفعلي للتقدم',

  // نظام مستوى العضوية
  'memberLevel.title': 'نظام مستوى العضوية',
  'memberLevel.description': 'اختر مستوى العضوية المناسب لك واستمتع بمزيد من المزايا والميزات',
  'memberLevel.free': 'عضو عادي',
  'memberLevel.silver': 'عضو فضي',
  'memberLevel.gold': 'عضو ذهبي',
  'memberLevel.diamond': 'عضو ماسي',
  'memberLevel.ultimate': 'عضو نهائي',
  'memberLevel.current': 'المستوى الحالي',
  'memberLevel.currentLevel': 'المستوى الحالي',
  'memberLevel.upgrade': 'ترقية الآن',
  'memberLevel.downgrade': 'تم فتحه',
  'memberLevel.feature.videoMonthly': 'إنشاء الفيديو الشهري',
  'memberLevel.feature.resolution': 'دقة الفيديو',
  'memberLevel.feature.tokens': 'رموز مجانية',
  'memberLevel.feature.queue': 'قائمة انتظار التوليد',
  'memberLevel.feature.storage': 'مساحة التخزين',
  'memberLevel.feature.imageMonthly': 'إنشاء الصور',
  'memberLevel.feature.commercial': 'ترخيص تجاري',
  'memberLevel.feature.api': 'الوصول إلى API',
  'memberLevel.feature.support': 'دعم عملاء مخصص',
  'memberLevel.feature.custom': 'خدمة مخصصة',

  // التحقق من الهوية
  'verification.title': 'التحقق من الهوية الحقيقية',
  'verification.subtitle': 'يرجى ملء معلوماتك الحقيقية وتحميل صور بطاقة الهوية، سنكمل المراجعة خلال 1-3 أيام عمل',
  'verification.back': 'رجوع',
  'verification.back.profile': 'العودة إلى الملف الشخصي',
  'verification.cancel': 'إلغاء',
  'verification.submit': 'تقديم التحقق',
  'verification.submit.success': 'تم التقديم بنجاح، في انتظار المراجعة',
  'verification.submit.error': 'فشل التقديم، يرجى المحاولة لاحقاً',
  'verification.verified.title': 'لقد أكملت التحقق من الهوية',
  'verification.verified.desc': 'معلومات التحقق:',
  'verification.step.info': 'ملء المعلومات',
  'verification.step.upload': 'تحميل المستندات',
  'verification.step.complete': 'اكتمال',
  'verification.info.title': 'نصائح مفيدة',
  'verification.info.desc': 'يرجى التأكد من أن صور بطاقة الهوية المحملة واضحة وكاملة. سيتم الحفاظ على سرية معلوماتك الشخصية وستستخدم فقط للتحقق من الهوية.',
  'verification.form.realName.label': 'الاسم الحقيقي',
  'verification.form.realName.required': 'يرجى إدخال اسمك الحقيقي',
  'verification.form.realName.invalid': 'تنسيق الاسم غير صحيح',
  'verification.form.realName.placeholder': 'يرجى إدخال الاسم كما في بطاقة الهوية',
  'verification.form.idType.label': 'نوع الوثيقة',
  'verification.form.idType.required': 'يرجى اختيار نوع الوثيقة',
  'verification.form.idType.sfz': 'بطاقة الهوية',
  'verification.form.idType.nrm': 'وثيقة عامة أخرى',
  'verification.form.cardNum.label': 'رقم الوثيقة',
  'verification.form.cardNum.required': 'يرجى إدخال رقم الوثيقة',
  'verification.form.cardNum.invalid': 'تنسيق رقم بطاقة الهوية غير صحيح',
  'verification.form.cardNum.placeholder': 'يرجى إدخال رقم بطاقة الهوية المكون من 18 رقماً',
  'verification.form.idCardFront.label': 'الوجه الأمامي لبطاقة الهوية',
  'verification.form.idCardBack.label': 'الوجه الخلفي لبطاقة الهوية',
  'verification.upload.required': 'يرجى تحميل صور الوجهين الأمامي والخلفي لبطاقة الهوية',
  'verification.upload.sizeLimit': 'حجم الملف لا يمكن أن يتجاوز 5MB',
  'verification.upload.front.text': 'انقر أو اسحب لتحميل الوجه الأمامي لبطاقة الهوية',
  'verification.upload.back.text': 'انقر أو اسحب لتحميل الوجه الخلفي لبطاقة الهوية',
  'verification.upload.hint': 'يدعم تنسيقات JPG و PNG، حجم ملف واحد لا يتجاوز 5MB',
  'verification.upload.reupload': 'إعادة التحميل',
  'verification.reviewing.title': 'التحقق من الهوية قيد المراجعة',
  'verification.reviewing.desc': 'مستندات التحقق من هويتك قيد المراجعة، من المتوقع الانتهاء خلال 1-3 أيام عمل',
  'verification.rejected.title': 'فشل التحقق من الهوية',
  'verification.rejected.desc': 'لم يتم قبول التحقق من هويتك',
  'verification.rejected.reason': 'سبب الرفض',
  'verification.resubmit': 'إعادة التقديم',
  'verification.info.name': 'الاسم:',
  'verification.info.idType': 'نوع الوثيقة:',
  'verification.info.idNumber': 'رقم الوثيقة:',
  'verification.info.country': 'البلد/المنطقة:',
  'verification.info.submitTime': 'وقت التقديم:',
  'verification.info.verifyTime': 'وقت التحقق:',
  'userMenu.status.reviewing': 'قيد المراجعة',
  'userMenu.status.rejected': 'لم يتم القبول',

  // نظام الإنجازات
  'achievement.category.all': 'الكل',
  'achievement.category.basic': 'أساسي',
  'achievement.category.creation': 'إبداع',
  'achievement.category.payment': 'شحن',
  'achievement.category.membership': 'عضوية',
  'achievement.category.level': 'مستوى',
  'achievement.category.social': 'اجتماعي',
  'achievement.category.works': 'أعمال',
  'achievement.level.current': 'المستوى الحالي: {level}',
  'achievement.stats.unlocked': 'تم فتحه',
  'achievement.stats.locked': 'مقفل',
  'achievement.stats.progress': 'نسبة الإنجاز',
  'achievement.stats.exp': 'الخبرة الحالية',

  // أعمالي
  'works.title': 'أعمالي',
  'works.description': 'إدارة وعرض جميع أعمالك المُنشأة',
  'works.refresh': 'تحديث',
  'works.stats.total': 'جميع الأعمال',
  'works.stats.images': 'صور',
  'works.stats.videos': 'مقاطع فيديو',
  'works.stats.audios': 'صوتيات',
  'works.stats.favorites': 'المفضلة',
  'works.search.placeholder': 'البحث في الأعمال...',
  'works.filter.all': 'جميع الأنواع',
  'works.filter.image': 'صورة',
  'works.filter.video': 'فيديو',
  'works.filter.audio': 'صوت',
  'works.date.start': 'تاريخ البدء',
  'works.date.end': 'تاريخ الانتهاء',
  'works.sort.date': 'حسب التاريخ',
  'works.sort.name': 'حسب الاسم',
  'works.sort.size': 'حسب الحجم',
  'works.sort.asc': 'تصاعدي',
  'works.sort.desc': 'تنازلي',
  'works.view.grid': 'شبكة',
  'works.view.list': 'قائمة',
  'works.type.video': 'فيديو',
  'works.type.image': 'صورة',
  'works.type.audio': 'صوت',
  'works.preview': 'معاينة',
  'works.download': 'تنزيل',
  'works.share': 'مشاركة',
  'works.delete': 'حذف',
  'works.deleteConfirm': 'هل أنت متأكد من حذف هذا العمل؟',
  'works.loadError': 'فشل تحميل الأعمال، يرجى المحاولة لاحقاً',
  'works.favoriteUpdated': 'تم تحديث حالة المفضلة',
  'works.favoriteError': 'فشل تحديث المفضلة',
  'works.downloading': 'جاري التنزيل...',
  'works.sharing': 'جاري إنشاء رابط المشاركة...',
  'works.deleted': 'تم حذف العمل',
  'works.deleteError': 'فشل الحذف، يرجى المحاولة لاحقاً',
  'works.empty.title': 'لا توجد أعمال',
  'works.empty.description': 'ابدأ في إنشاء عملك الأول!',
  'works.empty.action': 'ابدأ الإبداع',
  'works.pagination.total': 'إجمالي {total} عنصر، يعرض {start}-{end}',

  // إنشاء الفيديو
  'create.video.generate.success': 'تم تقديم مهمة إنشاء الفيديو، يرجى الانتظار للنتيجة',
  'create.video.generate.failed': 'فشل إنشاء الفيديو، يرجى المحاولة مرة أخرى',
  'create.video.generate.cancel': 'إلغاء الإنشاء',
  'create.video.generate.cancelled': 'تم إلغاء إنشاء الفيديو',
  'create.aspectRatio.3:4': '3:4 (عمودي كلاسيكي)',
  'create.model.select.image.placeholder': 'يرجى اختيار نموذج إنشاء الصور',
  'create.model.price.perImage': '/صورة',
  'create.image.format': 'تنسيق الإخراج',

  // صفحة About
  'about.hero.title1': 'نواة مفتوحة المصدر.',
  'about.hero.title2': 'إمكانيات لا نهائية.',
  'about.hero.subtitle1': 'مبني على',
  'about.hero.subtitle2': 'و',
  'about.hero.subtitle3': 'النظام البيئي.',
  'about.hero.description': 'نحزم أحدث تقنيات الذكاء الاصطناعي التوليدي لعام 2025 في تجربة تفاعلية مثالية.',
  'about.tech.poweredBy': 'مدعوم بـ',
  'about.philosophy.title1': 'أكثر من مجرد توليد.',
  'about.philosophy.title2': 'هذا محرك إبداع',
  'about.philosophy.title3': 'شامل.',
  'about.philosophy.description': 'من التحكم الدقيق في النص إلى الصورة إلى محاكاة الفيزياء في توليد الفيديو، نسعى إلى حدود التكنولوجيا.',
  'about.bento.comfy.title': 'تحكم دقيق على مستوى العقد.',
  'about.bento.comfy.description': 'مبني على بنية عقد ComfyUI، يدعم التحكم في الوضعية ControlNet ونقل الأسلوب IP-Adapter. نحول منطق العقد المعقد إلى أشرطة تمرير بديهية، مما يجعل كل توليد تمامًا كما تتخيل.',
  'about.bento.opensource.title': 'احتضان المصدر المفتوح.',
  'about.bento.opensource.description': 'مبني على Stable Diffusion 3.5 & XL Turbo. ليس فقط توليد فائق السرعة، بل أيضًا دعم ضخم لنماذج LoRA من المجتمع.',
  'about.bento.video.title': 'بنية فيديو DiT.',
  'about.bento.video.description': 'تقديم Diffusion Transformer (DiT) مع آلية الانتباه المكاني-الزماني، لتحقيق محاكاة العالم المادي بمستوى SORA.',
  'about.bento.audio.title': 'مزامنة الصوت والصورة، إيقاظ الحواس.',
  'about.bento.audio.description': 'أكثر من مجرد مرئي. متكامل مع أحدث نماذج توليد الصوت، يدعم Text-to-Audio والمحاذاة التلقائية للفيديو. من البصر إلى السمع، بناء تجربة غامرة كاملة.',
  'about.techSection.title': 'البنية التقنية.',
  'about.techSection.description': 'تعمق في المحرك الأساسي الذي يشغل ProductX.',
  'about.techCard.sd.title': 'أساس الفن التوليدي.',
  'about.techCard.sd.description': 'ندمج بعمق أحدث نماذج توليد Stable Diffusion. من خلال VAE مخصص وعينات محسنة، نحقق توليدًا أسرع بنسبة 300% مع الحفاظ على جودة صورة رائعة.',
  'about.techCard.spec.baseModel': 'النموذج الأساسي',
  'about.techCard.spec.resolution': 'الدقة',
  'about.techCard.spec.resolution.value': 'حتى 4K Upscaling',
  'about.techCard.spec.control': 'التحكم',
  'about.techCard.spec.speed': 'السرعة',
  'about.techCard.spec.speed.value': '< 1 ثانية (وضع تربو)',
  'about.techCard.video.title': 'محرك فيزياء الفيديو من الجيل التالي.',
  'about.techCard.video.description': 'التخلي عن منطق الرسوم المتحركة ثنائية الأبعاد التقليدي، واعتماد أحدث بنية DiT (Diffusion Transformer) لعام 2025. يفهم النموذج الإضاءة والجاذبية وفيزياء الحركة، ولا ينشئ مقاطع فيديو فحسب، بل عوالم ديناميكية دقيقة فيزيائيًا.',
  'about.techCard.spec.architecture': 'البنية',
  'about.techCard.spec.frameRate': 'معدل الإطارات',
  'about.techCard.spec.frameRate.value': 'استيفاء 24 / 60 FPS',
  'about.techCard.spec.consistency': 'الاتساق',
  'about.techCard.spec.consistency.value': 'استقرار زمني عالٍ',
  'about.techCard.spec.length': 'المدة',
  'about.techCard.spec.length.value': 'تمديد حلقة لا نهائية',
  'about.techCard.img2img.title': 'صورة إلى صورة ونقل الأسلوب.',
  'about.techCard.img2img.description': 'باستخدام تقنيات IP-Adapter و T2I-Adapter، نحقق نقل أسلوب zero-shot. قم بتحميل صورة مرجعية لنسخ تركيبها وإضاءتها وأسلوبها الفني فورًا، مما يفتح إمكانيات إبداعية لا نهائية.',
  'about.techCard.spec.technology': 'التقنية',
  'about.techCard.spec.precision': 'الدقة',
  'about.techCard.spec.precision.value': 'ترقيع بكسل مثالي',
  'about.cta.title': 'هل أنت مستعد لتجربة المستقبل؟',
  'about.cta.description': 'انضم إلى صفوف المبدعين المحترفين وأطلق العنان للإمكانات القصوى للذكاء الاصطناعي.',
  'about.cta.button.start': 'ابدأ الآن',
  'about.cta.button.docs': 'اقرأ الوثائق',
  
  // Community المجتمع
  'community.explore.title': 'استكشف المجتمعات',
  'community.explore.subtitle': 'اكتشف الإلهام، واعيد مزج سير العمل، وتواصل مع آلاف منشئي الذكاء الاصطناعي.',
  'community.posts': '{count} منشور',
  'community.empty': 'لا توجد قنوات مجتمعية',
  'community.loadFailed': 'فشل التحميل',
  'community.noPosts': 'لا توجد منشورات بعد',
  'community.challenge.loadFailed': 'فشل تحميل بيانات التحدي',
  
  'common.loadFailed': 'فشل التحميل',
  'common.operationFailed': 'فشلت العملية',
  'common.error': 'فشلت العملية',
  'common.publish': 'نشر',
  'common.back': 'رجوع',
  'common.backToCommunity': 'العودة إلى المجتمع',
  'common.copy': 'نسخ',
  'common.copied': 'تم النسخ',
  'common.follow': 'متابعة',
  'common.processing': 'جاري المعالجة...',
  'common.viewCount': '{count} مشاهدة',
  'common.loadMore': 'تحميل المزيد',
  'common.search': 'بحث...',
  'common.notFound': 'غير موجود',
  'common.description': 'الوصف',
  
  'user.followSuccess': 'تمت المتابعة بنجاح',
  'user.unfollowSuccess': 'تم إلغاء المتابعة بنجاح',
  'user.following': 'متابع',
  'user.mutual_follow': 'متبادل',
  
  'post.untitled': 'إبداع بدون عنوان',
  'post.prompt': 'الموجه',
  'post.negativePrompt': 'الموجه السلبي',
  'post.details': 'التفاصيل',
  'post.model': 'النموذج',
  'post.resolution': 'الدقة',
  'post.steps': 'الخطوات',
  'post.cfgScale': 'مقياس التوجيه',
  'post.remix': 'إعادة المزج / جرب هذا',
  
  'challenge.status.upcoming': 'قريباً',
  'challenge.status.live': 'مباشر الآن',
  'challenge.status.voting': 'التصويت',
  'challenge.status.ended': 'انتهى',
  'challenge.status.unknown': 'غير معروف',
  'challenge.allChallenges': 'جميع التحديات',
  'challenge.entriesCount': '{count} مشاركة',
  'challenge.tab.submissions': 'المشاركات',
  'challenge.tab.rules': 'القواعد والمعلومات',
  'challenge.requirements': 'المتطلبات',
  'challenge.req.original': 'إبداعات أصلية فقط.',
  'challenge.req.model': 'يجب استخدام النموذج: {model}',
  'challenge.req.tags': 'يجب تضمين العلامات:',
  'challenge.req.resolution': 'يجب أن تكون الدقة على الأقل 1024x1024.',
  'challenge.req.nsfw': 'لا يُسمح بالمحتوى غير المناسب.',
  'challenge.timeRemaining': 'الوقت المتبقي',
  'challenge.startsIn': 'يبدأ في',
  'challenge.notStarted': 'لم يبدأ التحدي بعد',
  'challenge.closed': 'التحدي مغلق',
  'challenge.submitEntry': 'إرسال المشاركة',
  'challenge.viewWinners': 'عرض الفائزين',
  'challenge.readRulesTip': 'اقرأ القواعد قبل الإرسال',
  'challenge.prizePool': 'جائزة',
  'challenge.totalValue': 'القيمة الإجمالية',
  'challenge.rank.1st': 'المركز الأول',
  'challenge.rank.2nd': 'المركز الثاني',
  'challenge.rank.3rd': 'المركز الثالث',
  'challenge.share': 'مشاركة التحدي',
  'challenge.noEntries': 'لا توجد مشاركات بعد. كن الأول!',
  'challenge.noChallenges': 'لم يتم العثور على تحديات',
  // MediaTools
  'mediaTools.tab.imageCompress': 'ضغط الصور',
  'mediaTools.tab.videoCompress': 'ضغط الفيديو',
  'mediaTools.tab.audioCompress': 'ضغط الصوت',
  'mediaTools.tab.formatConvert': 'تحويل التنسيق',
  // ImageCompress
  'imageCompress.title': 'أداة ضغط الصور الاحترافية',
  'imageCompress.subtitle': 'ضغط ذكي، جودة احترافية',
  'imageCompress.upload': 'رفع الصور',
  'imageCompress.addImages': 'إضافة الصور',
  'imageCompress.uploadToStart': 'قم برفع الصور لبدء الضغط',
  'imageCompress.settings': 'الإعدادات',
  'imageCompress.clearAll': 'مسح الكل',
  'imageCompress.totalSavings': 'المساحة المُوفرة',
  'imageCompress.totalSize': 'الحجم الإجمالي',
  'imageCompress.quality': 'الجودة',
  'imageCompress.resize': 'تغيير الحجم',
  'imageCompress.scalePercent': 'النسبة %',
  'imageCompress.customPx': 'بكسل مخصص',
  'imageCompress.presetSize': 'الحجم المحدد مسبقاً',
  'imageCompress.width': 'العرض',
  'imageCompress.height': 'الارتفاع',
  'imageCompress.format': 'التنسيق',
  'imageCompress.format.auto': 'تلقائي (الأصلي)',
  'imageCompress.format.jpeg': 'JPEG (صورة)',
  'imageCompress.format.png': 'PNG (بدون فقدان)',
  'imageCompress.format.webp': 'WebP (الأفضل)',
  'imageCompress.pngLossless': 'PNG بدون فقدان. شريط الجودة مخفي.',
  'imageCompress.cacheSettings': 'إعدادات التخزين المؤقت',
  'imageCompress.cacheTooltip': 'عند التفعيل، سيتم حفظ الصور المرفوعة في التخزين المؤقت للمتصفح واستعادتها بعد تحديث الصفحة.',
  'imageCompress.saveToCache': 'حفظ الصور في التخزين المؤقت للمتصفح',
  'imageCompress.batchProcessing': 'المعالجة المجمعة',
  'imageCompress.batchTooltip': 'عند التفعيل، سيتم تطبيق الضغط على جميع الصور {count} بالإعدادات الحالية.',
  'imageCompress.applyToAll': 'تطبيق الإعدادات على جميع الصور ({count})',
  'imageCompress.compress': 'تطبيق وضغط',
  'imageCompress.compressAll': 'تطبيق وضغط الكل ({count})',
  'imageCompress.compressing': 'جارٍ الضغط...',
  'imageCompress.compressAllProgress': 'جارٍ ضغط {count} صورة...',
  'imageCompress.download': 'تنزيل الصورة',
  'imageCompress.downloadAll': 'تنزيل الكل ({count})',
  'imageCompress.downloadAllCheckbox': 'تنزيل جميع الصور {count}',
  'imageCompress.original': 'الأصلي',
  'imageCompress.compressed': 'المضغوط',
  // Messages
  'imageCompress.message.compressed': 'تم الضغط بنجاح!',
  'imageCompress.message.larger': 'ملف الإخراج أكبر. حاول تقليل الجودة.',
  'imageCompress.message.failed': 'فشل الضغط',
  'imageCompress.message.batchSuccess': 'تم ضغط {success} صورة بنجاح{failed}',
  'imageCompress.message.batchFailed': 'فشل جميع عمليات الضغط',
  'imageCompress.message.noImagesToDownload': 'لا توجد صور مضغوطة للتنزيل',
  'imageCompress.message.downloading': 'جارٍ تنزيل {count} صورة...',
  // Preset sizes
  'imageCompress.preset.instagramPost': 'منشور Instagram (1:1)',
  'imageCompress.preset.square': 'مربع (1:1)',
  'imageCompress.preset.facebookCover': 'غلاف Facebook (16:9)',
  'imageCompress.preset.twitterHeader': 'رأس Twitter (3:1)',
  'imageCompress.preset.youtubeThumbnail': 'صورة مصغرة YouTube (16:9)',
  'imageCompress.preset.facebookPost': 'منشور Facebook (1.91:1)',
  'imageCompress.preset.instagramStory': 'قصة Instagram (9:16)',
  'imageCompress.preset.tiktok': 'TikTok (9:16)',
  'imageCompress.preset.4kUHD': '4K UHD (16:9)',
  'imageCompress.preset.2kQHD': '2K QHD (16:9)',
  'imageCompress.preset.fullHD': 'Full HD (16:9)',
  'imageCompress.preset.hd': 'HD (16:9)',
  'imageCompress.preset.landscape16:9': 'أفقية 16:9',
  'imageCompress.preset.classic4:3': 'كلاسيكية 4:3',
  'imageCompress.preset.photo3:2': 'صورة 3:2',
  'imageCompress.preset.ultrawide21:9': 'فائقة العرض 21:9',
  'imageCompress.preset.a4Portrait': 'A4 عمودي (8.27×11.69")',
  'imageCompress.preset.a4Landscape': 'A4 أفقي (11.69×8.27")',
  'imageCompress.preset.letterPortrait': 'Letter عمودي (8.5×11")',
  // AudioCompress
  'audioCompress.title': 'أداة ضغط الصوت الاحترافية',
  'audioCompress.subtitle': 'ضغط قائم على المتصفح، خصوصية محمية',
  'audioCompress.upload': 'تحميل الصوت',
  'audioCompress.uploadNew': 'انقر لتحميل صوت جديد',
  'audioCompress.uploadToStart': 'قم بتحميل الصوت لبدء الضغط',
  'audioCompress.settings': 'الإعدادات',
  'audioCompress.clearAll': 'مسح الكل',
  'audioCompress.totalSavings': 'المساحة المحفوظة',
  'audioCompress.totalSize': 'الحجم الإجمالي',
  'audioCompress.audioInfo': 'معلومات الصوت',
  'audioCompress.quality': 'الجودة',
  'audioCompress.bitrate': 'معدل البت',
  'audioCompress.bitrate.320': '320 كيلوبت/ثانية (أعلى جودة)',
  'audioCompress.bitrate.256': '256 كيلوبت/ثانية (جودة عالية)',
  'audioCompress.bitrate.192': '192 كيلوبت/ثانية (جودة قياسية)',
  'audioCompress.bitrate.128': '128 كيلوبت/ثانية (جودة متوسطة)',
  'audioCompress.bitrate.96': '96 كيلوبت/ثانية (جودة منخفضة)',
  'audioCompress.bitrate.64': '64 كيلوبت/ثانية (أدنى جودة)',
  'audioCompress.format': 'التنسيق',
  'audioCompress.format.mp3': 'MP3 (موصى به)',
  'audioCompress.format.ogg': 'OGG',
  'audioCompress.format.aac': 'AAC',
  'audioCompress.format.wav': 'WAV',
  'audioCompress.sampleRate': 'معدل العينة',
  'audioCompress.sampleRate.48000': '48000 هرتز',
  'audioCompress.sampleRate.44100': '44100 هرتز (جودة CD)',
  'audioCompress.sampleRate.32000': '32000 هرتز',
  'audioCompress.sampleRate.22050': '22050 هرتز',
  'audioCompress.sampleRate.16000': '16000 هرتز',
  'audioCompress.compress': 'بدء الضغط',
  'audioCompress.compressing': 'جاري الضغط...',
  'audioCompress.download': 'تنزيل الصوت',
  // AudioCompress Messages
  'audioCompress.message.compressed': 'تم الضغط بنجاح!',
  'audioCompress.message.failed': 'فشل الضغط، يرجى المحاولة مرة أخرى',
  'audioCompress.message.invalidFile': 'الرجاء تحديد ملف صوتي!',
  'audioCompress.message.loadError': 'فشل تحميل الملف الصوتي',

  // Settings
  'settings.title': 'إعدادات النظام',
  'settings.description': 'خصص تجربة منصة التوليد بالذكاء الاصطناعي',
  'settings.notifications.title': 'إعدادات الإشعارات',
  'settings.notifications.description': 'إدارة طريقة استلام الإشعارات',
  'settings.notifications.email': 'إشعارات البريد',
  'settings.notifications.emailDesc': 'استلام التحديثات وإكمال المهام',
  'settings.notifications.push': 'الإشعارات الفورية',
  'settings.notifications.pushDesc': 'استلام الرسائل الفورية',
  'settings.notifications.sound': 'تنبيهات صوتية',
  'settings.notifications.soundDesc': 'تشغيل صوت عند الإشعار',
  'settings.notifications.volume': 'حجم الإشعارات',
  'settings.notifications.volumeDesc': 'ضبط مستوى الصوت',
  'settings.notifications.marketing': 'التسويق',
  'settings.notifications.marketingDesc': 'فعاليات وعروض المنصة',
  'settings.interface.title': 'مظهر الواجهة',
  'settings.interface.description': 'تخصيص العرض',
  'settings.interface.theme': 'المظهر',
  'settings.interface.themeDesc': 'اختر المظهر',
  'settings.interface.language': 'اللغة',
  'settings.interface.languageDesc': 'لغة الواجهة',
  'settings.interface.animation': 'الرسوم المتحركة',
  'settings.interface.animationDesc': 'تفعيل انتقالات الواجهة',
  'settings.interface.tips': 'نصائح للمبتدئين',
  'settings.interface.tipsDesc': 'عرض الأدلة والنصائح',
  'settings.theme.light': 'فاتح',
  'settings.theme.dark': 'داكن',
  'settings.theme.auto': 'تلقائي',
  'settings.ai.title': 'إعدادات التوليد بالذكاء الاصطناعي',
  'settings.ai.description': 'تحسين الجودة والأداء',
  'settings.ai.autoOptimize': 'تحسين تلقائي',
  'settings.ai.autoOptimizeDesc': 'الذكاء الاصطناعي يضبط المعلمات تلقائياً',
  'settings.ai.quality': 'جودة التوليد',
  'settings.ai.qualityDesc': 'التوازن بين السرعة والجودة',
  'settings.ai.cloudSync': 'مزامنة السحابة',
  'settings.ai.cloudSyncDesc': 'مزامنة الأعمال إلى السحابة',
  'settings.ai.autoSave': 'حفظ تلقائي',
  'settings.ai.autoSaveDesc': 'حفظ النتائج بعد التوليد',
  'settings.ai.safetyFilter': 'فلتر المحتوى',
  'settings.ai.safetyFilterDesc': 'تصفية المحتوى غير المناسب',
  'settings.ai.watermark': 'علامة مائية',
  'settings.ai.watermarkDesc': 'إضافة علامة مائية تلقائياً',
  'settings.ai.promptSuggestions': 'اقتراحات الإدخال',
  'settings.ai.promptSuggestionsDesc': 'اقتراحات لتحسين الإدخال',
  'settings.quality.fast': 'سريع',
  'settings.quality.balanced': 'متوازن',
  'settings.quality.high': 'جودة عالية',
  'settings.privacy.title': 'الخصوصية والأمان',
  'settings.privacy.description': 'حماية بياناتك الشخصية',
  'settings.privacy.profile': 'ظهور الملف الشخصي',
  'settings.privacy.profileDesc': 'السماح للآخرين بعرض ملفك',
  'settings.privacy.activity': 'حالة النشاط',
  'settings.privacy.activityDesc': 'إظهار أنك متصل',
  'settings.privacy.analytics': 'جمع البيانات التحليلية',
  'settings.privacy.analyticsDesc': 'مساعدتنا على تحسين المنتج',
  'settings.privacy.showWorks': 'ظهور الأعمال',
  'settings.privacy.showWorksDesc': 'السماح للآخرين بعرض أعمالك',
  'settings.privacy.allowComments': 'السماح بالتعليقات',
  'settings.privacy.allowCommentsDesc': 'السماح للآخرين بالتعليق',
  'settings.privacy.allowDownload': 'السماح بالتنزيل',
  'settings.privacy.allowDownloadDesc': 'السماح للآخرين بالتنزيل',
  'settings.performance.title': 'الأداء',
  'settings.performance.description': 'ضبط أداء النظام',
  'settings.performance.hardware': 'تسريع العتاد',
  'settings.performance.hardwareDesc': 'استخدام تسريع GPU',
  'settings.performance.preview': 'جودة المعاينة',
  'settings.performance.previewDesc': 'مستوى جودة المعاينة',
  'settings.performance.autoClean': 'تنظيف الذاكرة المؤقتة',
  'settings.performance.autoCleanDesc': 'حذف الملفات المؤقتة دورياً',
  'settings.performance.imageCompression': 'ضغط الصور',
  'settings.performance.imageCompressionDesc': 'ضغط الصور المرفوعة',
  'settings.performance.lazyLoading': 'تحميل متأخر',
  'settings.performance.lazyLoadingDesc': 'تأخير تحميل المحتوى',
  'settings.preview.low': 'منخفض',
  'settings.preview.medium': 'متوسط',
  'settings.preview.high': 'عالي',
  'settings.workflow.title': 'سير العمل',
  'settings.workflow.description': 'تخصيص سير التوليد',
  'settings.workflow.resolution': 'الدقة الافتراضية',
  'settings.workflow.resolutionDesc': 'الحجم الافتراضي للصور',
  'settings.workflow.saveHistory': 'حفظ السجل',
  'settings.workflow.saveHistoryDesc': 'حفظ المعلمات والإدخالات',
  'settings.workflow.autoTag': 'وسوم ذكية',
  'settings.workflow.autoTagDesc': 'إضافة وسوم تلقائياً',
  'settings.workflow.template': 'القوالب',
  'settings.workflow.templateDesc': 'تفعيل قوالب سير العمل',
  'settings.file.title': 'إدارة الملفات',
  'settings.file.description': 'التخزين والنسخ الاحتياطي',
  'settings.file.autoBackup': 'نسخ احتياطي تلقائي',
  'settings.file.autoBackupDesc': 'نسخ الملفات المهمة تلقائياً',
  'settings.file.backupFrequency': 'تكرار النسخ',
  'settings.file.backupFrequencyDesc': 'اختيار التكرار',
  'settings.file.realtime': 'فوري',
  'settings.file.daily': 'يومي',
  'settings.file.weekly': 'أسبوعي',
  'settings.file.autoOrganize': 'تنظيم تلقائي',
  'settings.file.autoOrganizeDesc': 'تصنيف الملفات تلقائياً',
  'settings.file.defaultFormat': 'التنسيق الافتراضي',
  'settings.file.defaultFormatDesc': 'تنسيق الحفظ الافتراضي',
  'settings.social.title': 'التفاعل الاجتماعي',
  'settings.social.description': 'الميزات الاجتماعية والصلاحيات',
  'settings.social.allowFollow': 'السماح بالمتابعة',
  'settings.social.allowFollowDesc': 'السماح للآخرين بمتابعتك',
  'settings.social.allowMessage': 'السماح بالرسائل',
  'settings.social.allowMessageDesc': 'السماح للآخرين بمراسلتك',
  'settings.social.likeNotify': 'إشعارات الإعجاب',
  'settings.social.likeNotifyDesc': 'الإشعار عند الإعجاب',
  'settings.social.mentionNotify': 'إشعارات الإشارة',
  'settings.social.mentionNotifyDesc': 'الإشعار عند الإشارة إليك',
  'settings.security.title': 'أمان الحساب',
  'settings.security.description': 'تعزيز الأمان',
  'settings.security.twoFactor': 'المصادقة الثنائية',
  'settings.security.twoFactorDesc': 'طبقة أمان إضافية',
  'settings.security.loginNotify': 'إشعارات تسجيل الدخول',
  'settings.security.loginNotifyDesc': 'الإشعار عند الدخول من جهاز جديد',
  'settings.security.deviceVerify': 'التحقق من الجهاز',
  'settings.security.deviceVerifyDesc': 'الأجهزة غير المعتمدة تحتاج تحققاً',
  'settings.security.autoLogout': 'تسجيل خروج تلقائي',
  'settings.security.autoLogoutDesc': 'الخروج بعد عدم النشاط',
  'settings.button.save': 'حفظ',
  'settings.button.reset': 'استعادة',
  'settings.badge.on': 'تشغيل',
  'settings.badge.recommended': 'موصى به',
  'settings.message.saveSuccess': 'تم حفظ الإعدادات',
  'settings.message.autoSaved': 'تم حفظ الإعدادات تلقائياً',
  'settings.message.saveFailed': 'فشل الحفظ',
  'settings.message.resetSuccess': 'تم استعادة الافتراضي',
  'settings.autoSaveHint': 'يتم حفظ الإعدادات تلقائياً',
  'settings.confirm.resetTitle': 'تأكيد الاستعادة',
  'settings.confirm.resetContent': 'استعادة جميع الإعدادات إلى القيمة الافتراضية؟',
  'settings.confirm.reset': 'استعادة',
  'settings.confirm.cancel': 'إلغاء',

  // Prompt Version History
  'prompt.version.label.prompt': 'الأمر',
  'prompt.version.label.negativePrompt': 'الأمر السلبي',
  'prompt.version.label.result': 'النتيجة',
}; 